import { Twirl as Hamburger } from 'hamburger-react';
import React, { useEffect, useRef, useState } from 'react';
import { BsInfoCircle, BsSearch } from 'react-icons/bs';
import { HashLink } from 'react-router-hash-link';

// icons
import {
    AiOutlineCalendar,
    AiOutlineCloseCircle
} from 'react-icons/ai';
import { BiHelpCircle } from 'react-icons/bi';
import { BsPersonVideo } from 'react-icons/bs';
import { CiLogin } from 'react-icons/ci';
import { RxHamburgerMenu } from "react-icons/rx";
// assets
import Apple from '../../Assets/Icons/LoginIcons/icons8-apple.svg';
import Google from '../../Assets/Icons/LoginIcons/icons8-google.svg';
import Microsoft from '../../Assets/Icons/LoginIcons/icons8-microsoft.svg';
import SecondPackage from '../../Assets/Video/Brand Launch Bundle_NewIconColor.mp4';
import CustomizeMySolution from '../../Assets/Video/Customize My Solution_NewIconColor.mp4';
import BundledVideo from '../../Assets/Video/Sales Team OnDemand_NewIconColor.mp4';
import CardOne from '../../Assets/img/Group 2 (5).webp';
import CardImageMoney from '../../Assets/img/Group 27077 (2).svg';
import CardThree from '../../Assets/img/Group_3_6.webp';
import CardTwo from '../../Assets/img/Group_4_4.webp';
import SearchNavImageThree from '../../Assets/img/Resource Center 2.0 (1).jpg';
import SearchNavImageTwo from '../../Assets/img/Virtual Lobby2.jpg';
import SearchNavImageOne from '../../Assets/img/image (20) (1) (1).png';
// components
import ContactUs from '../Communication/ContactUs';
interface NavProps {
	budnles: boolean;
	LoginMenuOpener: boolean;
	LetsTalkOpener: boolean;
	setLetsTalkOpener: React.Dispatch<React.SetStateAction<any>>;
	setBundles: React.Dispatch<React.SetStateAction<any>>;
	One: boolean;
	Two: boolean;
	Three: boolean;
	Four: boolean;
	recources: boolean;
	setNumber: React.Dispatch<React.SetStateAction<any>>;
	setLoginMenuOpener: React.Dispatch<React.SetStateAction<any>>;
	setOne: React.Dispatch<React.SetStateAction<any>>;
	setFour: React.Dispatch<React.SetStateAction<any>>;
	setTwo: React.Dispatch<React.SetStateAction<any>>;
	setThree: React.Dispatch<React.SetStateAction<any>>;
	setExploreButton: React.Dispatch<React.SetStateAction<any>>;
	setRecources: React.Dispatch<React.SetStateAction<any>>;
	isOpen: boolean;
	setOpen: React.Dispatch<React.SetStateAction<any>>;
}
// due to the constant change in the architecture many props have been depricated but are present, might be used again in the future :)
const NavBar: React.FC<NavProps> = ({
	LoginMenuOpener,
	setLoginMenuOpener,
	budnles,
	setBundles,
	LetsTalkOpener,
	setLetsTalkOpener,
	One,
	Two,
	Three,
	Four,
	isOpen,
	setOpen,
	recources,
	setNumber,
	setOne,
	setTwo,
	setThree,
	setFour,
	setExploreButton,
	setRecources,
}) => {
	const [isScrolled, setIsScrolled] = useState(false); // State to check if the user has scrolled down
	const [isOpend, setOpend] = useState(false); // hamburger menu state
	const [searchMenuOpen, setSearchMenuOpen] = useState(false);
	const [solutionsMenuOpen, setSolutionsMenuOpen] = useState(false);
	const [membershipMenuOpen, setmembershipMenuOpen] = useState(false);
	const [shoppingMenuShow, setshoppingMenuShow] = useState(false);
	const [accountMenuShow, setAccountMenuShow] = useState(false);
	const [loginMenuisShowing, setLoginMenuisShowing] = useState(false);
	const [clickedOutsideOfLogin, setclickedOutsideOfLogin] = useState(false);
	const [letsTalkMenu, setLetsTalkMenu] = useState(false);
	const [initialImage, setInitialImage] = useState(true);
	const [SalesMenu, setSalesMenu] = useState(false);
	const [Business, setBusiness] = useState(false);
	const [BrandCreative, setBrandCreative] = useState(false);
	const [digitalMarketing, setdigitalMarketing] = useState(false);
	const [CopyContent, setCopyContent] = useState(false);
	const [VideoProduction, setVideoProduction] = useState(false);
	const [webAndTech, setwebAndTech] = useState(false);
	const [BuildMyTeam, setBuildMyTeam] = useState(false);
	const [LoginMessage, setLoginMessage] = useState(false);
	const [InfoSenderOpen, setInfoSenderOpen] = useState(false);
	const [AccountHoverIconOne, SetAccountHoverIconOne] = useState(false);
	const [AccountHoverIconTwo, SetAccountHoverIconTwo] = useState(false);
	const [ExploreMenu, setExploreMenu] = useState(false);
	const [BuildMyBundleIsOpen, setBuildMyBundle] = useState(false);
	const [MyRoleOpener, setMyRoleOpener] = useState(false);
	const [MyGrowthStageOpener, setMyGrowthStageOpener] = useState(false);
	// mobile states
	const [mobileSearch, setMobileSearch] = useState(false);
	const [Cart, setCart] = useState(false);
	const [profileUser, setProfileUser] = useState(false);
	const [mainMenuMobile, setMainMenuMobile] = useState(true);
	const videoRefSecondVideo = useRef<HTMLVideoElement | null>(null);
	const videoRefFirstVideo = useRef<HTMLVideoElement | null>(null);
	const videoRefThirdVideo = useRef<HTMLVideoElement | null>(null);
	const linkRef = useRef<HTMLInputElement>(null);
	const [showOverlay, setShowOverlay] = useState(false);
	const [city, setCity] = useState('Seattle');
	const [date, setDate] = useState('');
	const [monthDate, setMonthDate] = useState('');
	const [isWideScreen, setIsWideScreen] = useState(window.innerWidth > 1280);
	const [email, setEmail] = useState('');
	const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();

		// Check if the entered password is correct
		if (
			email === 'Joe@salesbox.io' ||
			email === 'joe@salesbox.io' ||
			email === 'sam@salesmrkt.com' ||
			email === 'Sam@salesmrkt.com' ||
			email === 'Sam@salesbox.io' ||
			email === 'sam@salesbox.io'
		) {
			// Redirect to the desired URL
			window.location.reload();
		} else {
			// Display an error message or take any other action for incorrect password
			alert('Account not found. Please Sign Up.');
		}
	};
	// state to conditionaly render an image on mobile and video on 700px plus sizes
	useEffect(() => {
		const handleResize = () => {
			setIsWideScreen(window.innerWidth > 1280);
		};

		// Add event listener for window resize
		window.addEventListener('resize', handleResize);

		// Remove event listener on component unmount
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);
	const current = new Date();
	const phoneNumber = '1-888-920-GROW';
	const copyToClipboard = (text: string) => {
		const textarea = document.createElement('textarea');
		textarea.value = text;
		document.body.appendChild(textarea);
		textarea.select();
		textarea.setSelectionRange(0, 99999);
		document.execCommand('copy');
		document.body.removeChild(textarea);
		alert('Copied to clipboard!');
	};
	useEffect(() => {
		const months = [
			'January',
			'February',
			'March',
			'April',
			'May',
			'June',
			'July',
			'August',
			'September',
			'October',
			'November',
			'December',
		];

		const month = months[current.getMonth()]; // Get the month name

		setDate(
			`${current.toLocaleTimeString([], {
				hour12: true,
				hour: 'numeric',
				minute: 'numeric',
			})}`
		);
		setMonthDate(`${month} ${current.getDate()}`);
	}, [current]);
	const handleButtonClick = () => {
		setShowOverlay(true);
	};

	const handleCloseOverlay = () => {
		setShowOverlay(false);
	};
	type ItemDictionary = {
		[key: string]: {
			to: string;
			onClick: () => void;
		};
	};
	const handleLoginNeededClick = () => {
		// function that shows a Login please button for a specific ammount of time
		setLoginMessage(true);
		setTimeout(() => {
			setLoginMessage(false);
		}, 9600);
	};

	const handleMouseEnter = () => {
		if (videoRefSecondVideo.current) {
			videoRefSecondVideo.current.play();
		}
	};

	const handleMouseLeave = () => {
		if (videoRefSecondVideo.current) {
			videoRefSecondVideo.current.pause();
		}
	};
	const handleMouseEnterThird = () => {
		if (videoRefThirdVideo.current) {
			videoRefThirdVideo.current.play();
		}
	};

	const handleMouseLeaveThird = () => {
		if (videoRefThirdVideo.current) {
			videoRefThirdVideo.current.pause();
		}
	};
	const handleMouseEnterFirstVideo = () => {
		if (videoRefFirstVideo.current) {
			videoRefFirstVideo.current.play();
		}
	};

	const handleMouseLeaveFirstVideo = () => {
		if (videoRefFirstVideo.current) {
			videoRefFirstVideo.current.pause();
		}
	};

	const handleClick = () => {
		setBundles(true); // Set the state to true on click

		setTimeout(() => {
			setBundles(false); // Revert the state back to false after 600ms
		}, 800);
	};
	useEffect(() => {
		// change the styling of the nav bar with this
		const handleScroll = () => {
			if (window.scrollY > 0) {
				// if Scroll Y is higher than 0 -> user scrolled down
				setIsScrolled(true);
			} else {
				setIsScrolled(false);
			}
		};
		window.addEventListener('scroll', handleScroll); // adding an event listiner to capture scroll
		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, []);
	useEffect(() => {
		if (LetsTalkOpener === true) {
			setInfoSenderOpen(!InfoSenderOpen);
		}
	}, [LetsTalkOpener]);

	//Search Functionality
	// add any new page that needs to show in the search bar results here - > can contain a function + route
	const [searchTerm, setSearchTerm] = useState<string>('');
	const [searchIsEmpty, setSearchIsEmpty] = useState<boolean>(true);
	const items = [
		'Sales & Strategy',
		'Business Development',
		'Brand & Creative',
		'Digital Marketing',
		'Copy & Content',
		'Video Production',
		'Web & Tech',
		'Build My Team',
		'Bundles',
		'All Products',
		'Explore',
		'Membership',
		'Experience',
		'Resource Center',
		'Virtual Lobby',
		'About Us',
		'Join the Team',
		'Hiring',
		'Certified Partner Community',
		'Enterprise-Grade',
		'Value-Driven',
		'OnDemand & Bundled Services',
		'Trusted Partner',
		'Advantage Plan',
	];
	const itemDictionary: ItemDictionary = {
		'Sales & Strategy': {
			to: '/#Solutions',
			onClick: () => {
				setNumber(20);
				setSearchMenuOpen(false);
				setOpend(false);
			},
		},
		'Business Development': {
			to: '/#Solutions',
			onClick: () => {
				setNumber(21);
				setSearchMenuOpen(false);
				setOpend(false);
			},
		},
		'Brand & Creative': {
			to: '/#Solutions',
			onClick: () => {
				setNumber(22);
				setSearchMenuOpen(false);
				setOpend(false);
			},
		},
		'Digital Marketing': {
			to: '/#Solutions',
			onClick: () => {
				setNumber(23);
				setSearchMenuOpen(false);
				setOpend(false);
			},
		},
		'Copy & Content': {
			to: '/#Solutions',
			onClick: () => {
				setNumber(24);
				setSearchMenuOpen(false);
				setOpend(false);
			},
		},
		'Video Production': {
			to: '/#Solutions',
			onClick: () => {
				setNumber(25);
				setSearchMenuOpen(false);
				setOpend(false);
			},
		},
		'Web & Tech': {
			to: '/#Solutions',
			onClick: () => {
				setNumber(26);
				setSearchMenuOpen(false);
				setOpend(false);
			},
		},
		'Build My Team': {
			to: '/#Solutions',
			onClick: () => {
				setNumber(27);
				setSearchMenuOpen(false);
				setOpend(false);
			},
		},
		Bundles: {
			to: '/#Bundles',
			onClick: () => {
				setOne(true);
				setTwo(false);
				setThree(false);
				setFour(false);
				setSearchMenuOpen(false);
				setOpend(false);
			},
		},
		'Enterprise-Grade': {
			to: '/#Bundles',
			onClick: () => {
				setOne(false);
				setTwo(false);
				setThree(true);
				setFour(false);
				setSearchMenuOpen(false);
				setOpend(false);
			},
		},
		'Value-Driven': {
			to: '/#Bundles',
			onClick: () => {
				setOne(true);
				setTwo(false);
				setThree(false);
				setFour(false);
				setSearchMenuOpen(false);
				setOpend(false);
			},
		},
		'OnDemand & Bundled Services': {
			to: '/#Bundles',
			onClick: () => {
				setOne(true);
				setTwo(false);
				setThree(false);
				setFour(false);
				setSearchMenuOpen(false);
				setOpend(false);
			},
		},
		'Advantage Plan': {
			to: '/#Bundles',
			onClick: () => {
				setOne(false);
				setTwo(true);
				setThree(false);
				setFour(false);
				setSearchMenuOpen(false);
				setOpend(false);
			},
		},
		'All Products': {
			to: '/#Experience',
			onClick: () => {
				setOne(false);
				setTwo(false);
				setThree(true);
				setFour(false);
				setSearchMenuOpen(false);
				setOpend(false);
			},
		},
		Membership: {
			to: '/',
			onClick: () => {
				setOne(false);
				setTwo(true);
				setThree(false);
				setFour(false);
				setSearchMenuOpen(false);
				setOpend(false);
			},
		},
		Experience: {
			to: '/#Experience',
			onClick: () => {
				setOne(false);
				setTwo(false);
				setThree(false);
				setFour(true);
				setSearchMenuOpen(false);
				setOpend(false);
			},
		},
		Explore: {
			to: '/#Explore',
			onClick: () => {
				setSearchMenuOpen(false);
				setOpend(false);
			},
		},
		'Resource Center': {
			to: '/#Resources',
			onClick: () => {
				setSearchMenuOpen(false);
				setRecources(true);
				setOpend(false);
			},
		},
		'Virtual Lobby': {
			to: '/lobby',
			onClick: () => {
				setSearchMenuOpen(false);
				setOpend(false);
			},
		},
		'About Us': {
			to: '/about',
			onClick: () => {
				setSearchMenuOpen(false);
				setOpend(false);
			},
		},
		'Join the Team': {
			to: '/team',
			onClick: () => {
				setSearchMenuOpen(false);
				setOpend(false);
			},
		},
		Hiring: {
			to: '/team',
			onClick: () => {
				setSearchMenuOpen(false);
				setOpend(false);
			},
		},
		'Certified Partner Community': {
			to: '/',
			onClick: () => {
				setSearchMenuOpen(false);
				setOpend(false);
			},
		},
		'Trusted Partner': {
			to: '/',
			onClick: () => {
				setSearchMenuOpen(false);
				setOpend(false);
			},
		},
		// Add similar entries for other items as needed
	};
	const filteredItems = items.filter((item) =>
		item.toLowerCase().includes(searchTerm.toLowerCase())
	);

	const clearSearch = () => {
		setSearchTerm('');
	};

	const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const trimmedValue = e.target.value.replace(/^\s+/g, ''); // Trim leading spaces
		setSearchTerm(trimmedValue);
		setSearchIsEmpty(trimmedValue.trim() === '');
	};
	// framer motion variants //
	const menuVars = {
		initial: {
			scaleY: 0,
		},
		animate: {
			scaleY: 1,
			transition: {
				duration: 0.4,
				ease: [0.12, 0, 0.39, 0],
			},
		},
		exit: {
			scaleY: 0,
			transition: {
				delay: 0.1,
				duration: 0.2,
				ease: [0.22, 1, 0.36, 1],
			},
		},
	};
	const containerVars = {
		initial: {
			transition: {
				staggerChildren: 0.09,
				staggerDirection: -1,
			},
		},
		open: {
			transition: {
				delayChildren: 0.3,
				staggerChildren: 0.09,
				staggerDirection: 1,
			},
		},
	};
	const mobileVars = {
		initial: {
			y: '120vh',
			transition: {
				ease: [0.37, 0, 0.63, 1],
				duration: 0.5,
			},
		},
		open: {
			y: '0',
			transition: {
				ease: [0.37, 0, 0.63, 1],
				duration: 0.7,
			},
		},
	};

	// framer motion variants end //

	useEffect(() => {
		if (clickedOutsideOfLogin === true) {
			setLoginMenuisShowing(false);
		}
	}, [clickedOutsideOfLogin]);

	return (
		<div
			onMouseLeave={() => {
				setSolutionsMenuOpen(false);
				setSearchMenuOpen(false);
				setmembershipMenuOpen(false);
				setAccountMenuShow(false);
				setshoppingMenuShow(false);
				setLetsTalkMenu(false);
				setSalesMenu(false);
				setInitialImage(true);
				setBusiness(false);
				setBrandCreative(false);
				setdigitalMarketing(false);
				setCopyContent(false);
				setVideoProduction(false);
				setwebAndTech(false);
				setBuildMyTeam(false);
			}}
			className="h-[80px] bg-[#4d4d4d]  fixed top-0 w-full text-white text-lg font-normal flex items-center justify-between pl-6 pr-6 xl:pr-0 xl:pl-0   transition-all duration-75 shadow-sm shadow-black/70 z-[9999]"
		>
			<ContactUs isOpen={InfoSenderOpen} setOpen={setInfoSenderOpen} />
			{/* First Third of the Menu  */}
			{isWideScreen && (
				<div className=" h-full pl-16 xl:flex items-center  relative  justify-start   hidden w-1/3">
					<div className="flex items-center gap-3 justify-center ">
						<div className="relative ">
							<div
								className="text-sm flex items-center justify-center group cursor-pointer    rounded-lg pl-2 pr-2"
								onMouseEnter={() => {
									setSolutionsMenuOpen(true);
									setSearchMenuOpen(false);
									setmembershipMenuOpen(false);
									setAccountMenuShow(false);
									setshoppingMenuShow(false);
									setLetsTalkMenu(false);
									setLoginMessage(false);
								}}
							>
								<p className="text-white h-full group-hover:text-lime-400   transition-all duration-100 ease-in  flex items-center justify-center w-full text-center  group relative cursor-pointer  text-base ">
									Shop
								</p>
								<h5
									className={`${
										solutionsMenuOpen
											? "ml-1 rotate-90 group-hover:text-lime-400  transition-all duration-200 ease-in"
											: "ml-1 transition-all duration-100 ease-in"
									}`}
								>
									{">"}
								</h5>
							</div>
							{solutionsMenuOpen && (
								<div
									onMouseLeave={() => {
										setSolutionsMenuOpen(false);
										setInitialImage(true);
									}}
									className="w-[100vw] h-[450px] z-[999] overflow-hidden bg-white absolute rounded-b shadow-lg grid  grid-cols-3 14xl:grid-cols-4 left-[-64px] top-[52px]"
								>
									<div className="w-full h-full   flex flex-col justify-center pl-16 pr-10 gap-5">
										<div
											onMouseEnter={() => {
												setSalesMenu(true);
												setInitialImage(false);
												setBusiness(false);
												setBrandCreative(false);
												setdigitalMarketing(false);
												setCopyContent(false);
												setVideoProduction(false);
												setwebAndTech(false);
												setBuildMyTeam(false);
												setLoginMessage(false);
											}}
											className="flex group items-center cursor-pointer justify-between"
										>
											<HashLink
												smooth
												onClick={() => {
													setNumber(18);
													setSolutionsMenuOpen(false);
												}}
												className="  relative cursor-pointer transition-all duration-75 text-base ease-in"
												to="/#Solutions"
											>
												<p className="text-black group-hover:text-lime-500  font-medium 2xl:text-xl transition-all duration-75 ease-in cursor-pointer">
													Sales & Strategy
												</p>
											</HashLink>
											<div>
												<svg
													className="fill-[#333] group-hover:fill-lime-500 transition-all duration-75 ease-in"
													width="11"
													height="19"
													viewBox="0 0 11 19"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M2.15156 0.425L10.5766 8.825C10.6766 8.925 10.7472 9.03333 10.7886 9.15C10.8306 9.26667 10.8516 9.39167 10.8516 9.525C10.8516 9.65833 10.8306 9.78333 10.7886 9.9C10.7472 10.0167 10.6766 10.125 10.5766 10.225L2.15156 18.65C1.91823 18.8833 1.62656 19 1.27656 19C0.926562 19 0.626563 18.875 0.376563 18.625C0.126563 18.375 0.00156299 18.0833 0.00156296 17.75C0.00156293 17.4167 0.126563 17.125 0.376563 16.875L7.72656 9.525L0.376562 2.175C0.143228 1.94167 0.0265612 1.65433 0.0265611 1.313C0.0265611 0.971002 0.151561 0.675 0.401561 0.425C0.651561 0.175 0.943228 0.0500001 1.27656 0.0500001C1.60989 0.05 1.90156 0.175 2.15156 0.425Z"
														fill=""
													/>
												</svg>
											</div>
										</div>
										<div
											onMouseEnter={() => {
												setSalesMenu(false);
												setInitialImage(false);
												setBusiness(true);
												setBrandCreative(false);
												setdigitalMarketing(false);
												setCopyContent(false);
												setVideoProduction(false);
												setwebAndTech(false);
												setBuildMyTeam(false);
												setLoginMessage(false);
											}}
											className="flex items-center group justify-between"
										>
											<HashLink
												smooth
												onClick={() => {
													setNumber(19);
													setSolutionsMenuOpen(false);
												}}
												className=" group relative cursor-pointer transition-all duration-75 text-base ease-in"
												to="/#Solutions"
											>
												<p className="text-black group-hover:text-lime-500  font-medium 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer">
													Business Development
												</p>
											</HashLink>
											<div>
												<svg
													className="fill-[#333] group-hover:fill-lime-500 transition-all duration-75 ease-in"
													width="11"
													height="19"
													viewBox="0 0 11 19"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M2.15156 0.425L10.5766 8.825C10.6766 8.925 10.7472 9.03333 10.7886 9.15C10.8306 9.26667 10.8516 9.39167 10.8516 9.525C10.8516 9.65833 10.8306 9.78333 10.7886 9.9C10.7472 10.0167 10.6766 10.125 10.5766 10.225L2.15156 18.65C1.91823 18.8833 1.62656 19 1.27656 19C0.926562 19 0.626563 18.875 0.376563 18.625C0.126563 18.375 0.00156299 18.0833 0.00156296 17.75C0.00156293 17.4167 0.126563 17.125 0.376563 16.875L7.72656 9.525L0.376562 2.175C0.143228 1.94167 0.0265612 1.65433 0.0265611 1.313C0.0265611 0.971002 0.151561 0.675 0.401561 0.425C0.651561 0.175 0.943228 0.0500001 1.27656 0.0500001C1.60989 0.05 1.90156 0.175 2.15156 0.425Z"
														fill=""
													/>
												</svg>
											</div>
										</div>
										<div
											onMouseEnter={() => {
												setSalesMenu(false);
												setInitialImage(false);
												setBusiness(false);
												setBrandCreative(true);
												setdigitalMarketing(false);
												setCopyContent(false);
												setVideoProduction(false);
												setwebAndTech(false);
												setBuildMyTeam(false);
												setLoginMessage(false);
											}}
											className="flex group items-center justify-between"
										>
											<HashLink
												smooth
												onClick={() => {
													setNumber(20);
													setSolutionsMenuOpen(false);
												}}
												className="  relative cursor-pointer transition-all duration-75 text-base ease-in"
												to="/#Solutions"
											>
												<p className="text-black group-hover:text-lime-500  font-medium 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer">
													Brand & Creative
												</p>
											</HashLink>
											<div>
												<svg
													className="fill-[#333] group-hover:fill-lime-500 transition-all duration-75 ease-in"
													width="11"
													height="19"
													viewBox="0 0 11 19"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M2.15156 0.425L10.5766 8.825C10.6766 8.925 10.7472 9.03333 10.7886 9.15C10.8306 9.26667 10.8516 9.39167 10.8516 9.525C10.8516 9.65833 10.8306 9.78333 10.7886 9.9C10.7472 10.0167 10.6766 10.125 10.5766 10.225L2.15156 18.65C1.91823 18.8833 1.62656 19 1.27656 19C0.926562 19 0.626563 18.875 0.376563 18.625C0.126563 18.375 0.00156299 18.0833 0.00156296 17.75C0.00156293 17.4167 0.126563 17.125 0.376563 16.875L7.72656 9.525L0.376562 2.175C0.143228 1.94167 0.0265612 1.65433 0.0265611 1.313C0.0265611 0.971002 0.151561 0.675 0.401561 0.425C0.651561 0.175 0.943228 0.0500001 1.27656 0.0500001C1.60989 0.05 1.90156 0.175 2.15156 0.425Z"
														fill=""
													/>
												</svg>
											</div>
										</div>
										<div
											onMouseEnter={() => {
												setSalesMenu(false);
												setInitialImage(false);
												setBusiness(false);
												setBrandCreative(false);
												setdigitalMarketing(true);
												setCopyContent(false);
												setVideoProduction(false);
												setwebAndTech(false);
												setBuildMyTeam(false);
												setLoginMessage(false);
											}}
											className="flex group items-center justify-between"
										>
											<HashLink
												smooth
												onClick={() => {
													setNumber(21);
													setSolutionsMenuOpen(false);
												}}
												className="  relative cursor-pointer transition-all duration-75 text-base ease-in"
												to="/#Solutions"
											>
												<p className="text-black group-hover:text-lime-500  font-medium 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer">
													Digital Marketing
												</p>
											</HashLink>
											<div>
												<svg
													className="fill-[#333] group-hover:fill-lime-500 transition-all duration-75 ease-in"
													width="11"
													height="19"
													viewBox="0 0 11 19"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M2.15156 0.425L10.5766 8.825C10.6766 8.925 10.7472 9.03333 10.7886 9.15C10.8306 9.26667 10.8516 9.39167 10.8516 9.525C10.8516 9.65833 10.8306 9.78333 10.7886 9.9C10.7472 10.0167 10.6766 10.125 10.5766 10.225L2.15156 18.65C1.91823 18.8833 1.62656 19 1.27656 19C0.926562 19 0.626563 18.875 0.376563 18.625C0.126563 18.375 0.00156299 18.0833 0.00156296 17.75C0.00156293 17.4167 0.126563 17.125 0.376563 16.875L7.72656 9.525L0.376562 2.175C0.143228 1.94167 0.0265612 1.65433 0.0265611 1.313C0.0265611 0.971002 0.151561 0.675 0.401561 0.425C0.651561 0.175 0.943228 0.0500001 1.27656 0.0500001C1.60989 0.05 1.90156 0.175 2.15156 0.425Z"
														fill=""
													/>
												</svg>
											</div>
										</div>
										<div
											onMouseEnter={() => {
												setSalesMenu(false);
												setInitialImage(false);
												setBusiness(false);
												setBrandCreative(false);
												setdigitalMarketing(false);
												setCopyContent(true);
												setVideoProduction(false);
												setwebAndTech(false);
												setBuildMyTeam(false);
												setLoginMessage(false);
											}}
											className="flex group items-center justify-between"
										>
											<HashLink
												smooth
												onClick={() => {
													setNumber(22);
													setSolutionsMenuOpen(false);
												}}
												className="relative cursor-pointer transition-all duration-75 text-base ease-in"
												to="/#Solutions"
											>
												<p className="text-black group-hover:text-lime-500  font-medium 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer">
													Copy & Content
												</p>
											</HashLink>
											<div>
												<svg
													className="fill-[#333] group-hover:fill-lime-500 transition-all duration-75 ease-in"
													width="11"
													height="19"
													viewBox="0 0 11 19"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M2.15156 0.425L10.5766 8.825C10.6766 8.925 10.7472 9.03333 10.7886 9.15C10.8306 9.26667 10.8516 9.39167 10.8516 9.525C10.8516 9.65833 10.8306 9.78333 10.7886 9.9C10.7472 10.0167 10.6766 10.125 10.5766 10.225L2.15156 18.65C1.91823 18.8833 1.62656 19 1.27656 19C0.926562 19 0.626563 18.875 0.376563 18.625C0.126563 18.375 0.00156299 18.0833 0.00156296 17.75C0.00156293 17.4167 0.126563 17.125 0.376563 16.875L7.72656 9.525L0.376562 2.175C0.143228 1.94167 0.0265612 1.65433 0.0265611 1.313C0.0265611 0.971002 0.151561 0.675 0.401561 0.425C0.651561 0.175 0.943228 0.0500001 1.27656 0.0500001C1.60989 0.05 1.90156 0.175 2.15156 0.425Z"
														fill=""
													/>
												</svg>
											</div>
										</div>
										<div
											onMouseEnter={() => {
												setSalesMenu(false);
												setInitialImage(false);
												setBusiness(false);
												setBrandCreative(false);
												setdigitalMarketing(false);
												setCopyContent(false);
												setVideoProduction(true);
												setwebAndTech(false);
												setBuildMyTeam(false);
												setLoginMessage(false);
											}}
											className="flex group items-center justify-between"
										>
											<HashLink
												smooth
												onClick={() => {
													setNumber(23);
													setSolutionsMenuOpen(false);
												}}
												className=" group relative cursor-pointer transition-all duration-75 text-base ease-in"
												to="/#Solutions"
											>
												<p className="text-black group-hover:text-lime-500  font-medium 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer">
													Video Production
												</p>
											</HashLink>
											<div>
												<svg
													className="fill-[#333] group-hover:fill-lime-500 transition-all duration-75 ease-in"
													width="11"
													height="19"
													viewBox="0 0 11 19"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M2.15156 0.425L10.5766 8.825C10.6766 8.925 10.7472 9.03333 10.7886 9.15C10.8306 9.26667 10.8516 9.39167 10.8516 9.525C10.8516 9.65833 10.8306 9.78333 10.7886 9.9C10.7472 10.0167 10.6766 10.125 10.5766 10.225L2.15156 18.65C1.91823 18.8833 1.62656 19 1.27656 19C0.926562 19 0.626563 18.875 0.376563 18.625C0.126563 18.375 0.00156299 18.0833 0.00156296 17.75C0.00156293 17.4167 0.126563 17.125 0.376563 16.875L7.72656 9.525L0.376562 2.175C0.143228 1.94167 0.0265612 1.65433 0.0265611 1.313C0.0265611 0.971002 0.151561 0.675 0.401561 0.425C0.651561 0.175 0.943228 0.0500001 1.27656 0.0500001C1.60989 0.05 1.90156 0.175 2.15156 0.425Z"
														fill=""
													/>
												</svg>
											</div>
										</div>
										<div
											onMouseEnter={() => {
												setSalesMenu(false);
												setInitialImage(false);
												setBusiness(false);
												setBrandCreative(false);
												setdigitalMarketing(false);
												setCopyContent(false);
												setVideoProduction(false);
												setwebAndTech(true);
												setBuildMyTeam(false);
												setLoginMessage(false);
											}}
											className="flex items-center group justify-between"
										>
											<HashLink
												smooth
												onClick={() => {
													setNumber(24);
													setSolutionsMenuOpen(false);
												}}
												className="  relative cursor-pointer transition-all duration-75 text-base ease-in"
												to="/#Solutions"
											>
												<p className="text-black hover:text-lime-500  font-medium 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer">
													Web & Tech
												</p>
											</HashLink>
											<div>
												<svg
													className="fill-[#333] group-hover:fill-lime-500 transition-all duration-75 ease-in"
													width="11"
													height="19"
													viewBox="0 0 11 19"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M2.15156 0.425L10.5766 8.825C10.6766 8.925 10.7472 9.03333 10.7886 9.15C10.8306 9.26667 10.8516 9.39167 10.8516 9.525C10.8516 9.65833 10.8306 9.78333 10.7886 9.9C10.7472 10.0167 10.6766 10.125 10.5766 10.225L2.15156 18.65C1.91823 18.8833 1.62656 19 1.27656 19C0.926562 19 0.626563 18.875 0.376563 18.625C0.126563 18.375 0.00156299 18.0833 0.00156296 17.75C0.00156293 17.4167 0.126563 17.125 0.376563 16.875L7.72656 9.525L0.376562 2.175C0.143228 1.94167 0.0265612 1.65433 0.0265611 1.313C0.0265611 0.971002 0.151561 0.675 0.401561 0.425C0.651561 0.175 0.943228 0.0500001 1.27656 0.0500001C1.60989 0.05 1.90156 0.175 2.15156 0.425Z"
														fill=""
													/>
												</svg>
											</div>
										</div>
										<div
											onMouseEnter={() => {
												setSalesMenu(false);
												setInitialImage(false);
												setBusiness(false);
												setBrandCreative(false);
												setdigitalMarketing(false);
												setCopyContent(false);
												setVideoProduction(false);
												setwebAndTech(false);
												setBuildMyTeam(true);
												setLoginMessage(false);
											}}
											className="flex group items-center justify-between"
										>
											<HashLink
												smooth
												onClick={() => {
													setNumber(25);
													setSolutionsMenuOpen(false);
												}}
												className="  relative cursor-pointer transition-all duration-75 text-base ease-in"
												to="/#Solutions"
											>
												<p className="text-black group-hover:text-lime-500  font-medium 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer">
													Build My Team
												</p>
											</HashLink>
											<div>
												<svg
													className="fill-[#333] group-hover:fill-lime-500 transition-all duration-75 ease-in"
													width="11"
													height="19"
													viewBox="0 0 11 19"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M2.15156 0.425L10.5766 8.825C10.6766 8.925 10.7472 9.03333 10.7886 9.15C10.8306 9.26667 10.8516 9.39167 10.8516 9.525C10.8516 9.65833 10.8306 9.78333 10.7886 9.9C10.7472 10.0167 10.6766 10.125 10.5766 10.225L2.15156 18.65C1.91823 18.8833 1.62656 19 1.27656 19C0.926562 19 0.626563 18.875 0.376563 18.625C0.126563 18.375 0.00156299 18.0833 0.00156296 17.75C0.00156293 17.4167 0.126563 17.125 0.376563 16.875L7.72656 9.525L0.376562 2.175C0.143228 1.94167 0.0265612 1.65433 0.0265611 1.313C0.0265611 0.971002 0.151561 0.675 0.401561 0.425C0.651561 0.175 0.943228 0.0500001 1.27656 0.0500001C1.60989 0.05 1.90156 0.175 2.15156 0.425Z"
														fill=""
													/>
												</svg>
											</div>
										</div>
										<div
											onMouseEnter={() => {
												setSalesMenu(false);
												setInitialImage(false);
												setBusiness(false);
												setBrandCreative(false);
												setdigitalMarketing(false);
												setCopyContent(false);
												setVideoProduction(false);
												setwebAndTech(false);
												setBuildMyTeam(false);
												setBuildMyBundle(true);
												setLoginMessage(false);
											}}
											className="flex items-center group justify-between"
										>
											<HashLink
												smooth
												onClick={() => {
													setNumber(26);
													setSolutionsMenuOpen(false);
												}}
												className="  relative cursor-pointer transition-all duration-75 text-base ease-in"
												to="/#Solutions"
											>
												<p className="text-black group-hover:text-lime-500  font-medium 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer">
													Customize My Solution
												</p>
											</HashLink>
											<div>
												<svg
													className="fill-[#333] group-hover:fill-lime-500 transition-all duration-75 ease-in"
													width="11"
													height="19"
													viewBox="0 0 11 19"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M2.15156 0.425L10.5766 8.825C10.6766 8.925 10.7472 9.03333 10.7886 9.15C10.8306 9.26667 10.8516 9.39167 10.8516 9.525C10.8516 9.65833 10.8306 9.78333 10.7886 9.9C10.7472 10.0167 10.6766 10.125 10.5766 10.225L2.15156 18.65C1.91823 18.8833 1.62656 19 1.27656 19C0.926562 19 0.626563 18.875 0.376563 18.625C0.126563 18.375 0.00156299 18.0833 0.00156296 17.75C0.00156293 17.4167 0.126563 17.125 0.376563 16.875L7.72656 9.525L0.376562 2.175C0.143228 1.94167 0.0265612 1.65433 0.0265611 1.313C0.0265611 0.971002 0.151561 0.675 0.401561 0.425C0.651561 0.175 0.943228 0.0500001 1.27656 0.0500001C1.60989 0.05 1.90156 0.175 2.15156 0.425Z"
														fill=""
													/>
												</svg>
											</div>
										</div>
									</div>
									<div className="w-full h-full  overflow-hidden">
										{SalesMenu && (
											<div className="w-full h-full items-start relative justify-start pr-10 pt-8 gap-3 flex flex-col pl-10">
												<div
													onClick={handleLoginNeededClick}
													className="flex items-center cursor-pointer group justify-start gap-6 w-full"
												>
													<p className="text-black group-hover:text-lime-500 text-base  font-medium  2xl:text-xl  transition-all duration-75 ease-in cursor-pointer">
														Sales Team OnDemand™
													</p>
												</div>
												<p
													onClick={handleLoginNeededClick}
													className="text-black hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer"
												>
													Strategy & Consulting
												</p>
												<p
													onClick={handleLoginNeededClick}
													className="text-black hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer"
												>
													Sales Support
												</p>
												{LoginMessage && (
													<span
														onClick={() => {
															// setLoginMenuisShowing(
															// 	true
															// );
															window.location.reload();

															setAccountMenuShow(false);
														}}
														className="p-2 flex bg-lime-500  text-black items-center justify-center gap-2 cursor-pointer absolute bottom-[18px] left-[10px] w-[90%]  rounded  text-center  font-semibold border-lime-500 border   overflow-hidden group   hover:bg-gradient-to-r hover:from-lime-500 hover:to-lime-400  hover:ring-2 hover:ring-offset-2 hover:ring-lime-400 transition-all ease-out duration-300 "
													>
														Please Login for Access
														<CiLogin />
													</span>
												)}
											</div>
										)}
										{Business && (
											<div className="w-full h-full items-start relative justify-start pr-10 pt-8 gap-3 flex flex-col pl-10">
												<div
													onClick={handleLoginNeededClick}
													className="flex items-center group justify-start gap-6"
												>
													<p className="text-black hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer">
														Campaigns OnDemand™
													</p>
												</div>
												<p
													onClick={handleLoginNeededClick}
													className="text-black hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer"
												>
													Lead Funnel
												</p>
												<p
													onClick={handleLoginNeededClick}
													className="text-black hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer"
												>
													Email Campaign
												</p>
												<p
													onClick={handleLoginNeededClick}
													className="text-black hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer"
												>
													LinkedIn Campaign
												</p>
												<p
													onClick={handleLoginNeededClick}
													className="text-black hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer"
												>
													Sales Calls
												</p>
												<p
													onClick={handleLoginNeededClick}
													className="text-black hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer"
												>
													Text Campaign
												</p>
												{LoginMessage && (
													<span
														onClick={() => {
															// setLoginMenuisShowing(
															// 	true
															// );
															window.location.reload();
															setAccountMenuShow(false);
														}}
														className="p-2 flex items-center bg-lime-500 text-black justify-center gap-2 cursor-pointer absolute bottom-[18px] left-[10px] w-[90%]  rounded  text-center  font-semibold border-lime-500 border   overflow-hidden group   hover:bg-gradient-to-r hover:from-lime-500 hover:to-lime-400  hover:ring-2 hover:ring-offset-2 hover:ring-lime-400 transition-all ease-out duration-300 "
													>
														Please Login for Access
														<CiLogin />
													</span>
												)}
											</div>
										)}
										{BrandCreative && (
											<div className="w-full h-full relative items-start justify-start pr-10 pt-8 gap-3 flex flex-col pl-10">
												<div
													onClick={handleLoginNeededClick}
													className="flex items-center group justify-start gap-6"
												>
													<p className="text-black group-hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer">
														Creative OnDemand™
													</p>
												</div>
												<p
													onClick={handleLoginNeededClick}
													className="text-black hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer"
												>
													Brand Strategy
												</p>
												<p
													onClick={handleLoginNeededClick}
													className="text-black hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer"
												>
													Logo Design
												</p>
												<p
													onClick={handleLoginNeededClick}
													className="text-black hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer"
												>
													Stationery Design
												</p>
												<p
													onClick={handleLoginNeededClick}
													className="text-black hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer"
												>
													Presentation Templates
												</p>
												<p
													onClick={handleLoginNeededClick}
													className="text-black hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer"
												>
													Full Brand Creation
												</p>

												{LoginMessage && (
													<span
														onClick={() => {
															// setLoginMenuisShowing(
															// 	true
															// );
															window.location.reload();
															setAccountMenuShow(false);
														}}
														className="p-2 flex bg-lime-500 text-black items-center justify-center gap-2 cursor-pointer absolute bottom-[18px] left-[10px] w-[90%]  rounded  text-center  font-semibold border-lime-500 border   overflow-hidden group   hover:bg-gradient-to-r hover:from-lime-500 hover:to-lime-400  hover:ring-2 hover:ring-offset-2 hover:ring-lime-400 transition-all ease-out duration-300 "
													>
														Please Login for Access
														<CiLogin />
													</span>
												)}
											</div>
										)}
										{digitalMarketing && (
											<div className="w-full h-full relative items-start justify-start pr-10 pt-8 gap-3 flex flex-col pl-10">
												<div
													onClick={handleLoginNeededClick}
													className="flex items-center group justify-start gap-6"
												>
													<p className="text-black group-hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer">
														Marketing OnDemand™
													</p>
												</div>
												<p
													onClick={handleLoginNeededClick}
													className="text-black hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer"
												>
													SEO Analysis
												</p>
												<p
													onClick={handleLoginNeededClick}
													className="text-black hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer"
												>
													SEO Optimization
												</p>
												<p
													onClick={handleLoginNeededClick}
													className="text-black hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer"
												>
													Social Media Management
												</p>
												<p
													onClick={handleLoginNeededClick}
													className="text-black hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer"
												>
													Paid Ads
												</p>
												{LoginMessage && (
													<span
														onClick={() => {
															// setLoginMenuisShowing(
															// 	true
															// );
															window.location.reload();
															setAccountMenuShow(false);
														}}
														className="p-2 flex bg-lime-500 text-black items-center justify-center gap-2 cursor-pointer absolute bottom-[18px] left-[10px] w-[90%]  rounded  text-center  font-semibold border-lime-500 border   overflow-hidden group   hover:bg-gradient-to-r hover:from-lime-500 hover:to-lime-400  hover:ring-2 hover:ring-offset-2 hover:ring-lime-400 transition-all ease-out duration-300 "
													>
														Please Login for Access
														<CiLogin />
													</span>
												)}
											</div>
										)}
										{CopyContent && (
											<div className="w-full h-full relative items-start justify-start pr-10 pt-8 gap-3 flex flex-col pl-10">
												<div
													onClick={handleLoginNeededClick}
													className="flex items-center group justify-start gap-[52px]"
												>
													<p className="text-black group-hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer">
														Copy OnDemand™
													</p>
												</div>
												<div
													onClick={handleLoginNeededClick}
													className="flex items-center group justify-start gap-6"
												>
													<p className="text-black group-hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer">
														Content OnDemand™
													</p>
												</div>
												<p
													onClick={handleLoginNeededClick}
													className="text-black hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer"
												>
													Website Content
												</p>
												<p
													onClick={handleLoginNeededClick}
													className="text-black hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer"
												>
													Content Strategy
												</p>
												<p
													onClick={handleLoginNeededClick}
													className="text-black hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer"
												>
													Content Management
												</p>
												<p
													onClick={handleLoginNeededClick}
													className="text-black hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer"
												>
													Content Creation
												</p>
												<p
													onClick={handleLoginNeededClick}
													className="text-black hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer"
												>
													Articles & Blogs
												</p>
												{LoginMessage && (
													<span
														onClick={() => {
															// setLoginMenuisShowing(
															// 	true
															// );
															window.location.reload();
															setAccountMenuShow(false);
														}}
														className="p-2 flex bg-lime-500 text-black items-center justify-center gap-2 cursor-pointer absolute bottom-[18px] left-[10px] w-[90%]  rounded  text-center  font-semibold border-lime-500 border   overflow-hidden group   hover:bg-gradient-to-r hover:from-lime-500 hover:to-lime-400  hover:ring-2 hover:ring-offset-2 hover:ring-lime-400 transition-all ease-out duration-300 "
													>
														Please Login for Access
														<CiLogin />
													</span>
												)}
											</div>
										)}
										{VideoProduction && (
											<div className="w-full relative h-full items-start justify-start pr-10 pt-8 gap-3 flex flex-col pl-10">
												<div
													onClick={handleLoginNeededClick}
													className="flex items-center group justify-start gap-6"
												>
													<p className="text-black group-hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer">
														Video OnDemand™
													</p>
												</div>
												<div
													onClick={handleLoginNeededClick}
													className="flex items-center justify-between w-full"
												>
													<p className="text-black hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer">
														Video Marketing
													</p>
												</div>
												<p
													onClick={handleLoginNeededClick}
													className="text-black hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer"
												>
													VSF
												</p>
												<p
													onClick={handleLoginNeededClick}
													className="text-black hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer"
												>
													Packages
												</p>
												<p
													onClick={handleLoginNeededClick}
													className="text-black hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer"
												>
													Types
												</p>
												<p
													onClick={handleLoginNeededClick}
													className="text-black hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer"
												>
													Explainer
												</p>
												<p
													onClick={handleLoginNeededClick}
													className="text-black hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer"
												>
													Live Action
												</p>
												<p
													onClick={handleLoginNeededClick}
													className="text-black hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer"
												>
													Testimonials
												</p>
												{LoginMessage && (
													<span
														onClick={() => {
															// setLoginMenuisShowing(
															// 	true
															// );
															window.location.reload();
															setAccountMenuShow(false);
														}}
														className="p-2 flex items-center bg-lime-500 text-black justify-center gap-2 cursor-pointer absolute bottom-[18px] left-[10px] w-[90%]  rounded  text-center  font-semibold border-lime-500 border   overflow-hidden group   hover:bg-gradient-to-r hover:from-lime-500 hover:to-lime-400  hover:ring-2 hover:ring-offset-2 hover:ring-lime-400 transition-all ease-out duration-300 "
													>
														Please Login for Access
														<CiLogin />
													</span>
												)}
											</div>
										)}
										{webAndTech && (
											<div className="w-full h-full relative items-start justify-start pr-10 pt-8 gap-3 flex flex-col pl-10">
												<div
													onClick={handleLoginNeededClick}
													className="flex items-center group justify-start gap-6"
												>
													<p className="text-black group-hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer">
														Dev. OnDemand™
													</p>
												</div>
												<div
													onClick={handleLoginNeededClick}
													className="flex items-center justify-between w-full"
												>
													<p className="text-black hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer">
														Web
													</p>
												</div>
												<p
													onClick={handleLoginNeededClick}
													className="text-black hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer"
												>
													Funnels
												</p>
												<p
													onClick={handleLoginNeededClick}
													className="text-black hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer"
												>
													Mobile
												</p>
												<p
													onClick={handleLoginNeededClick}
													className="text-black hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer"
												>
													Digital Products
												</p>
												{LoginMessage && (
													<span
														onClick={() => {
															// setLoginMenuisShowing(
															// 	true
															// );
															window.location.reload();
															setAccountMenuShow(false);
														}}
														className="p-2 flex bg-lime-500 text-black items-center justify-center gap-2 cursor-pointer absolute bottom-[18px] left-[10px] w-[90%]  rounded  text-center  font-semibold border-lime-500 border   overflow-hidden group   hover:bg-gradient-to-r hover:from-lime-500 hover:to-lime-400  hover:ring-2 hover:ring-offset-2 hover:ring-lime-400 transition-all ease-out duration-300 "
													>
														Please Login for Access
														<CiLogin />
													</span>
												)}
											</div>
										)}
										{BuildMyTeam && (
											<div className="w-full h-full relative items-start justify-start pr-10 pt-8 gap-3 flex flex-col pl-10">
												<div
													onClick={handleLoginNeededClick}
													className="flex items-center group justify-start gap-6"
												>
													<p className="text-black group-hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer">
														Team OnDemand™
													</p>
												</div>
												<div
													onClick={handleLoginNeededClick}
													className="flex items-center justify-between w-full"
												>
													<p className="text-black hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer">
														Resource
													</p>
												</div>
												<p
													onClick={handleLoginNeededClick}
													className="text-black hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer"
												>
													Fractional Roles
												</p>
												<p
													onClick={handleLoginNeededClick}
													className="text-black hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer"
												>
													Recruiting
												</p>
												<p
													onClick={handleLoginNeededClick}
													className="text-black hover:text-lime-500  font-medium text-base 2xl:text-xl  transition-all duration-75 ease-in cursor-pointer"
												>
													Coaching
												</p>
												{LoginMessage && (
													<span
														onClick={() => {
															// setLoginMenuisShowing(
															// 	true
															// );
															window.location.reload();
															setAccountMenuShow(false);
														}}
														className="p-2 flex items-center bg-lime-500 text-black justify-center gap-2 cursor-pointer absolute bottom-[18px] left-[10px] w-[90%]  rounded  text-center  font-semibold border-lime-500 border   overflow-hidden group   hover:bg-gradient-to-r hover:from-lime-500 hover:to-lime-400  hover:ring-2 hover:ring-offset-2 hover:ring-lime-400 transition-all ease-out duration-300 "
													>
														Please Login for Access
														<CiLogin />
													</span>
												)}
											</div>
										)}
										{BuildMyBundleIsOpen && (
											<div
												onMouseEnter={handleMouseEnterFirstVideo}
												onMouseLeave={handleMouseLeaveFirstVideo}
												className="w-full  h-full relative  "
											>
												<HashLink
													smooth
													onClick={() => {
														setNumber(26);
														setSolutionsMenuOpen(false);
													}}
													className=" w-full cursor-pointer h-full "
													to="/#Solutions"
												>
													<video
														loop
														ref={videoRefFirstVideo}
														muted
														playsInline
														disablePictureInPicture
														preload={"auto"}
														className="w-full h-full  object-cover"
														src={CustomizeMySolution}
													></video>
												</HashLink>
											</div>
										)}
									</div>
									<div
										onMouseEnter={handleMouseEnter}
										onMouseLeave={handleMouseLeave}
										className="w-full h-full hidden cursor-pointer  14xl:flex  overflow-hidden"
									>
										<HashLink
											smooth
											onClick={() => {
												setOne(true);
												setTwo(false);
												setThree(false);
												setFour(false);
												setSolutionsMenuOpen(false);
											}}
											className=" w-full cursor-pointer h-full "
											to="/#Bundles"
										>
											<video
												loop
												muted
												playsInline
												disablePictureInPicture
												preload="auto"
												className="w-full h-full object-cover"
												src={BundledVideo}
												ref={videoRefSecondVideo}
											></video>
										</HashLink>
									</div>
									<div
										onMouseEnter={handleMouseEnterThird}
										onMouseLeave={handleMouseLeaveThird}
										className="w-full h-full   overflow-hidden"
									>
										<HashLink
											smooth
											onClick={() => {
												setOne(true);
												setTwo(false);
												setThree(false);
												setFour(false);
												setSolutionsMenuOpen(false);
											}}
											className=" w-full cursor-pointer h-full "
											to="/#Bundles"
										>
											<video
												loop
												muted
												playsInline
												disablePictureInPicture
												preload="auto"
												className="w-full cursor-pointer h-full object-cover"
												src={SecondPackage}
												ref={videoRefThirdVideo}
											></video>
										</HashLink>
									</div>
								</div>
							)}
						</div>
						<div
							className="flex items-center group relative w-fit justify-center"
							onClick={() => {
								setSearchMenuOpen(true);
								setSolutionsMenuOpen(false);
								setmembershipMenuOpen(false);
								setAccountMenuShow(false);
								setshoppingMenuShow(false);
								setLetsTalkMenu(false);
							}}
						>
							<BsSearch className="h-[15px] mr-1 w-[15px] absolute cursor-pointer transition-all right-[8px] text-white group-hover:text-lime-400 " />
							{!searchIsEmpty && (
								<AiOutlineCloseCircle
									onClick={() => {
										clearSearch();
										setSearchIsEmpty(true);
									}}
									className="h-[15px] mr-1 w-[15px] cursor-pointer transition-all absolute rotate-180 left-[8px] text-white hover:text-lime-500"
								/>
							)}
							<input
								type="text"
								style={{ display: "none" }}
								autoComplete="username"
								tabIndex={-1}
								readOnly
							/>
							<input
								type="text"
								name="SearchBarInput"
								placeholder="Search"
								value={searchTerm}
								onChange={handleSearchChange}
								className={`${
									searchIsEmpty
										? "bg-[#4d4d4d] outline-slate-100/40  outline outline-1 p-[2px] pl-2  pr-20  placeholder-gray-200/70 text-sm  rounded-lg"
										: "bg-[#4d4d4d] outline-slate-100/40  outline outline-1 p-[2px] pl-8 pr-[56px]  placeholder-gray-200/70 text-sm  rounded-lg"
								}' rounded-md '`}
								id="Searcher"
								// onFocus={(event) => {
								// 	event.target.setAttribute(
								// 		'autocomplete',
								// 		'off'
								// 	);
								// }}
								autoComplete="new-password"
							/>
						</div>
					</div>
					{searchMenuOpen && (
						<div
							onMouseLeave={() => {
								setSearchMenuOpen(false);
								setExploreMenu(false);
								setMyRoleOpener(false);
								setMyGrowthStageOpener(false);
							}}
							className="w-[100vw] z-[999] h-[450px] overflow-hidden bg-white absolute rounded-b shadow-lg grid  grid-cols-4 left-[0px] top-[80px]"
						>
							<div className="flex flex-col items-start pl-10 pr-10 gap-6 overflow-hidden justify-start">
								<input
									type="text"
									name="OtherSearchItem"
									value={searchTerm}
									onChange={handleSearchChange}
									placeholder="Search for ..."
									className=" p-1 mt-2 w-full text-black outline-none focus:outline-none placeholder-gray-800/70 text-xl mb-1  border-b border-black/50 "
									id="OtherSearch"
								/>
								{!searchIsEmpty && (
									<ul className="overflow-hidden mb-4 ">
										{filteredItems.map((item, index) => (
											<li
												onClick={() => {
													const dictionaryItem = itemDictionary[item];
													if (dictionaryItem) {
														const { to, onClick } = dictionaryItem;
														onClick(); // Call the onClick function for the item
														setmembershipMenuOpen(false);
														setSearchMenuOpen(false);
													}
												}}
												className="text-black"
												key={index}
											>
												{itemDictionary[item] ? (
													<HashLink
														smooth
														className="text-black group relative hover:text-lime-500 text-center cursor-pointer transition-all duration-75 text-xl ease-in"
														to={itemDictionary[item].to}
													>
														{item}
													</HashLink>
												) : (
													<span className="text-black">{item}</span>
												)}
											</li>
										))}
									</ul>
								)}
								{searchIsEmpty && (
									<div className="flex w-full flex-col items-center justify-center gap-2">
										<div className="flex group items-center justify-between w-full">
											<HashLink
												smooth
												onClick={() => {
													setTwo(false);
													setOne(false);
													setThree(true);
													setFour(false);
													setSearchMenuOpen(false);
												}}
												className="text-black group-hover:text-lime-500  relative cursor-pointer transition-all duration-100 text-xl ease-in"
												to="/#Experience"
											>
												All Products
											</HashLink>
											<div>
												<svg
													className="group-hover:fill-lime-500 transition-all duration-75 fill-[#333]"
													width="11"
													height="19"
													viewBox="0 0 11 19"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M2.15156 0.425L10.5766 8.825C10.6766 8.925 10.7472 9.03333 10.7886 9.15C10.8306 9.26667 10.8516 9.39167 10.8516 9.525C10.8516 9.65833 10.8306 9.78333 10.7886 9.9C10.7472 10.0167 10.6766 10.125 10.5766 10.225L2.15156 18.65C1.91823 18.8833 1.62656 19 1.27656 19C0.926562 19 0.626563 18.875 0.376563 18.625C0.126563 18.375 0.00156299 18.0833 0.00156296 17.75C0.00156293 17.4167 0.126563 17.125 0.376563 16.875L7.72656 9.525L0.376562 2.175C0.143228 1.94167 0.0265612 1.65433 0.0265611 1.313C0.0265611 0.971002 0.151561 0.675 0.401561 0.425C0.651561 0.175 0.943228 0.0500001 1.27656 0.0500001C1.60989 0.05 1.90156 0.175 2.15156 0.425Z"
														fill=""
													/>
												</svg>
											</div>
										</div>
										<div className="flex items-center group justify-between w-full gap-2">
											<HashLink
												smooth
												className="text-black  flex items-center  justify-center gap-2 relative cursor-pointer   group-hover:text-lime-500    transition-all duration-75 text-lg ease-in"
												onClick={() => {
													setExploreButton(true);
													setSearchMenuOpen(false);
												}}
												to="/"
											>
												OnDemand™
											</HashLink>
											<div>
												<svg
													className="group-hover:fill-lime-500 transition-all duration-75 fill-[#333]"
													width="11"
													height="19"
													viewBox="0 0 11 19"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M2.15156 0.425L10.5766 8.825C10.6766 8.925 10.7472 9.03333 10.7886 9.15C10.8306 9.26667 10.8516 9.39167 10.8516 9.525C10.8516 9.65833 10.8306 9.78333 10.7886 9.9C10.7472 10.0167 10.6766 10.125 10.5766 10.225L2.15156 18.65C1.91823 18.8833 1.62656 19 1.27656 19C0.926562 19 0.626563 18.875 0.376563 18.625C0.126563 18.375 0.00156299 18.0833 0.00156296 17.75C0.00156293 17.4167 0.126563 17.125 0.376563 16.875L7.72656 9.525L0.376562 2.175C0.143228 1.94167 0.0265612 1.65433 0.0265611 1.313C0.0265611 0.971002 0.151561 0.675 0.401561 0.425C0.651561 0.175 0.943228 0.0500001 1.27656 0.0500001C1.60989 0.05 1.90156 0.175 2.15156 0.425Z"
														fill=""
													/>
												</svg>
											</div>
										</div>
										<div className="flex items-center group justify-between w-full">
											<HashLink
												smooth
												onClick={() => {
													setTwo(false);
													setOne(false);
													setThree(true);
													setFour(false);
													setSearchMenuOpen(false);
												}}
												className="text-black group-hover:text-lime-500  relative cursor-pointer transition-all duration-100 text-xl ease-in"
												to="/#Solutions"
											>
												Solutions
											</HashLink>
											<div>
												<svg
													className="group-hover:fill-lime-500 transition-all duration-75 fill-[#333]"
													width="11"
													height="19"
													viewBox="0 0 11 19"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M2.15156 0.425L10.5766 8.825C10.6766 8.925 10.7472 9.03333 10.7886 9.15C10.8306 9.26667 10.8516 9.39167 10.8516 9.525C10.8516 9.65833 10.8306 9.78333 10.7886 9.9C10.7472 10.0167 10.6766 10.125 10.5766 10.225L2.15156 18.65C1.91823 18.8833 1.62656 19 1.27656 19C0.926562 19 0.626563 18.875 0.376563 18.625C0.126563 18.375 0.00156299 18.0833 0.00156296 17.75C0.00156293 17.4167 0.126563 17.125 0.376563 16.875L7.72656 9.525L0.376562 2.175C0.143228 1.94167 0.0265612 1.65433 0.0265611 1.313C0.0265611 0.971002 0.151561 0.675 0.401561 0.425C0.651561 0.175 0.943228 0.0500001 1.27656 0.0500001C1.60989 0.05 1.90156 0.175 2.15156 0.425Z"
														fill=""
													/>
												</svg>
											</div>
										</div>

										<div
											onMouseEnter={() => {
												setExploreMenu(false);
												setMyGrowthStageOpener(false);
												setMyRoleOpener(false);
											}}
											className="flex items-center group justify-between w-full"
										>
											<div
												onClick={() => {
													setOne(true);
													setTwo(false);
													setThree(false);
													setFour(false);
													setSearchMenuOpen(false);
												}}
												className="w-fit"
											>
												<HashLink
													smooth
													className="text-black  relative   group-hover:text-lime-500   text-center  cursor-pointer transition-all duration-75 text-xl ease-in"
													to="/#Bundles"
												>
													Packages
												</HashLink>
											</div>
											<div>
												<svg
													className="group-hover:fill-lime-500 transition-all duration-75 fill-[#333]"
													width="11"
													height="19"
													viewBox="0 0 11 19"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M2.15156 0.425L10.5766 8.825C10.6766 8.925 10.7472 9.03333 10.7886 9.15C10.8306 9.26667 10.8516 9.39167 10.8516 9.525C10.8516 9.65833 10.8306 9.78333 10.7886 9.9C10.7472 10.0167 10.6766 10.125 10.5766 10.225L2.15156 18.65C1.91823 18.8833 1.62656 19 1.27656 19C0.926562 19 0.626563 18.875 0.376563 18.625C0.126563 18.375 0.00156299 18.0833 0.00156296 17.75C0.00156293 17.4167 0.126563 17.125 0.376563 16.875L7.72656 9.525L0.376562 2.175C0.143228 1.94167 0.0265612 1.65433 0.0265611 1.313C0.0265611 0.971002 0.151561 0.675 0.401561 0.425C0.651561 0.175 0.943228 0.0500001 1.27656 0.0500001C1.60989 0.05 1.90156 0.175 2.15156 0.425Z"
														fill=""
													/>
												</svg>
											</div>
										</div>
										<div
											onMouseEnter={() => {
												setExploreMenu(false);
												setMyGrowthStageOpener(false);
												setMyRoleOpener(false);
											}}
											className="flex items-center group justify-between w-full"
										>
											<HashLink
												smooth
												className="text-black  relative cursor-pointer   group-hover:text-lime-500   text-center transition-all duration-75 text-xl ease-in"
												onClick={() => {
													setOne(true);
													setTwo(false);
													setThree(false);
													setFour(false);
													setSearchMenuOpen(false);
												}}
												to="/#Bundles"
											>
												Bundles
											</HashLink>
											<div>
												<svg
													className="group-hover:fill-lime-500 transition-all duration-75 fill-[#333]"
													width="11"
													height="19"
													viewBox="0 0 11 19"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M2.15156 0.425L10.5766 8.825C10.6766 8.925 10.7472 9.03333 10.7886 9.15C10.8306 9.26667 10.8516 9.39167 10.8516 9.525C10.8516 9.65833 10.8306 9.78333 10.7886 9.9C10.7472 10.0167 10.6766 10.125 10.5766 10.225L2.15156 18.65C1.91823 18.8833 1.62656 19 1.27656 19C0.926562 19 0.626563 18.875 0.376563 18.625C0.126563 18.375 0.00156299 18.0833 0.00156296 17.75C0.00156293 17.4167 0.126563 17.125 0.376563 16.875L7.72656 9.525L0.376562 2.175C0.143228 1.94167 0.0265612 1.65433 0.0265611 1.313C0.0265611 0.971002 0.151561 0.675 0.401561 0.425C0.651561 0.175 0.943228 0.0500001 1.27656 0.0500001C1.60989 0.05 1.90156 0.175 2.15156 0.425Z"
														fill=""
													/>
												</svg>
											</div>
										</div>
										<div
											onMouseEnter={() => setExploreMenu(true)}
											className="flex items-center justify-between w-full"
										>
											<HashLink
												smooth
												className="text-black group relative cursor-pointer   hover:text-lime-500   text-center transition-all duration-75 text-xl ease-in"
												onClick={() => {
													setExploreButton(true);
													setSearchMenuOpen(false);
												}}
												to="/#Explore"
											>
												Explore
											</HashLink>
											<div>
												<svg
													className={`${
														ExploreMenu
															? "fill-lime-500 transition-all duration-100 ease-in"
															: "fill-[#333] transition-all duration-100 ease-in"
													} transition-all duration-150 ease-in`}
													width="11"
													height="19"
													viewBox="0 0 11 19"
													fill=""
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M2.15156 0.425L10.5766 8.825C10.6766 8.925 10.7472 9.03333 10.7886 9.15C10.8306 9.26667 10.8516 9.39167 10.8516 9.525C10.8516 9.65833 10.8306 9.78333 10.7886 9.9C10.7472 10.0167 10.6766 10.125 10.5766 10.225L2.15156 18.65C1.91823 18.8833 1.62656 19 1.27656 19C0.926562 19 0.626563 18.875 0.376563 18.625C0.126563 18.375 0.00156299 18.0833 0.00156296 17.75C0.00156293 17.4167 0.126563 17.125 0.376563 16.875L7.72656 9.525L0.376562 2.175C0.143228 1.94167 0.0265612 1.65433 0.0265611 1.313C0.0265611 0.971002 0.151561 0.675 0.401561 0.425C0.651561 0.175 0.943228 0.0500001 1.27656 0.0500001C1.60989 0.05 1.90156 0.175 2.15156 0.425Z"
														fill=""
													/>
												</svg>
											</div>
										</div>
										{ExploreMenu && (
											<div className="w-full flex flex-col items-start pl-4  justify-start gap-3">
												<div
													onMouseEnter={() => {
														setMyRoleOpener(false);
														setMyGrowthStageOpener(false);
													}}
													className="flex items-center justify-between w-full"
												>
													<HashLink
														smooth
														className="text-black group relative cursor-pointer   hover:text-lime-500   text-center transition-all duration-75 text-lg ease-in"
														onClick={() => {
															setExploreButton(true);
															setSearchMenuOpen(false);
														}}
														to="/"
													>
														Quick Look
													</HashLink>
												</div>
												<div
													onMouseEnter={() => {
														setMyRoleOpener(false);
														setMyGrowthStageOpener(false);
													}}
													className="flex items-center justify-between w-full"
												>
													<HashLink
														smooth
														className="text-black group relative cursor-pointer   hover:text-lime-500   text-center transition-all duration-75 text-lg ease-in"
														onClick={() => {
															setExploreButton(true);
															setSearchMenuOpen(false);
														}}
														to="/"
													>
														Top Sellers
													</HashLink>
												</div>

												<div
													onMouseEnter={() => {
														setMyRoleOpener(true);
														setMyGrowthStageOpener(false);
													}}
													className="flex items-center justify-between w-full"
												>
													<HashLink
														smooth
														className="text-black  group relative cursor-pointer   hover:text-lime-500   text-center transition-all duration-75 text-lg ease-in"
														onClick={() => {
															setExploreButton(true);
															setSearchMenuOpen(false);
														}}
														to="/"
													>
														My Role
													</HashLink>
													<div>
														<svg
															className={`${
																MyRoleOpener ? "fill-lime-500" : "fill-[#333]"
															}`}
															width="11"
															height="19"
															viewBox="0 0 11 19"
															fill="none"
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																d="M2.15156 0.425L10.5766 8.825C10.6766 8.925 10.7472 9.03333 10.7886 9.15C10.8306 9.26667 10.8516 9.39167 10.8516 9.525C10.8516 9.65833 10.8306 9.78333 10.7886 9.9C10.7472 10.0167 10.6766 10.125 10.5766 10.225L2.15156 18.65C1.91823 18.8833 1.62656 19 1.27656 19C0.926562 19 0.626563 18.875 0.376563 18.625C0.126563 18.375 0.00156299 18.0833 0.00156296 17.75C0.00156293 17.4167 0.126563 17.125 0.376563 16.875L7.72656 9.525L0.376562 2.175C0.143228 1.94167 0.0265612 1.65433 0.0265611 1.313C0.0265611 0.971002 0.151561 0.675 0.401561 0.425C0.651561 0.175 0.943228 0.0500001 1.27656 0.0500001C1.60989 0.05 1.90156 0.175 2.15156 0.425Z"
																fill=""
															/>
														</svg>
													</div>
												</div>
												<div
													onMouseEnter={() => {
														setMyRoleOpener(false);
														setMyGrowthStageOpener(true);
													}}
													className="flex items-center justify-between w-full"
												>
													<HashLink
														smooth
														className="text-black  group relative cursor-pointer   hover:text-lime-500   text-center transition-all duration-75 text-lg ease-in"
														onClick={() => {
															setExploreButton(true);
															setSearchMenuOpen(false);
														}}
														to="/"
													>
														My Growth Stage
													</HashLink>
													<div>
														<svg
															className={`${
																MyGrowthStageOpener
																	? "fill-lime-500"
																	: "fill-[#333]"
															}`}
															width="11"
															height="19"
															viewBox="0 0 11 19"
															fill="none"
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																d="M2.15156 0.425L10.5766 8.825C10.6766 8.925 10.7472 9.03333 10.7886 9.15C10.8306 9.26667 10.8516 9.39167 10.8516 9.525C10.8516 9.65833 10.8306 9.78333 10.7886 9.9C10.7472 10.0167 10.6766 10.125 10.5766 10.225L2.15156 18.65C1.91823 18.8833 1.62656 19 1.27656 19C0.926562 19 0.626563 18.875 0.376563 18.625C0.126563 18.375 0.00156299 18.0833 0.00156296 17.75C0.00156293 17.4167 0.126563 17.125 0.376563 16.875L7.72656 9.525L0.376562 2.175C0.143228 1.94167 0.0265612 1.65433 0.0265611 1.313C0.0265611 0.971002 0.151561 0.675 0.401561 0.425C0.651561 0.175 0.943228 0.0500001 1.27656 0.0500001C1.60989 0.05 1.90156 0.175 2.15156 0.425Z"
																fill=""
															/>
														</svg>
													</div>
												</div>
											</div>
										)}
									</div>
								)}
							</div>
							<div className="w-full h-full   relative overflow-hidden">
								{!MyRoleOpener && !MyGrowthStageOpener && (
									<div className="w-full h-full   relative overflow-hidden">
										<HashLink
											smooth
											className="cursor-pointer relative w-full h-full   group    text-white font-semibold     text-base ease-in"
											to={"/lobby"}
										>
											<div className="w-full h-full bg-gradient-to-t from-black/90 via-transparent absolute"></div>

											<img
												src={SearchNavImageTwo}
												className="w-full h-full object-cover  "
												alt=""
											/>
											<div className="flex items-center absolute bottom-[30px] left-[35%] transition-all duration-200  group justify-start gap-2">
												<p className=" transition-all group-hover:text-lime-500 duration-200  ease-in cursor-pointer">
													Virtual Lobby
												</p>

												<svg
													width="23"
													height="15"
													viewBox="0 0 889 553"
													className=" fill-white group-hover:fill-lime-500 transition-all duration-200  ease-in"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M0.199951 275.8C0.199951 217.4 -0.100049 159 0.399951 100.6C0.499951 88.6004 2.39995 76.4004 4.99995 64.6004C12.3 31.2004 33.7 11.2004 66.8 4.60041C80.6 1.80041 94.8 0.300415 108.9 0.300415C190.2 0.00041455 271.4 0.300415 352.7 0.400415C388.1 0.300415 423.6 0.000414543 459 0.000414543C491.8 0.000414543 524.6 -0.299585 557.4 0.500415C570.1 0.800415 583 2.60041 595.4 5.40041C629.2 13.0004 648.9 34.9004 655.4 68.5004C657.7 80.5004 659.2 92.9004 659.2 105.1C659.5 209.3 659.6 313.5 659.4 417.6C659.4 437.8 659 458.3 656.3 478.3C650.6 519.4 626.4 543 585.3 549.3C573 551.2 560.5 552.3 548 552.3C479.2 552.5 410.5 552.3 341.7 552.2C294.4 552.1 247.2 552.1 199.9 552.1C167.9 552.1 136 552.6 104 551.9C90.5 551.6 76.7 549.7 63.5 546.7C30.0999 539.1 10.6 517.3 4.19995 484.1C1.69995 471.3 0.299951 458 0.199951 445C-0.200049 388.6 -4.88274e-05 332.2 -4.88274e-05 275.8C0.0999512 275.8 0.199951 275.8 0.199951 275.8Z"
														fill=""
													/>
													<path
														d="M888.7 60.5C888.7 204.4 888.7 347.6 888.7 491.4C887.1 490.7 885.8 490.3 884.6 489.6C826.6 458.3 768.7 427 710.7 395.9C706.7 393.8 705.5 391.3 705.5 387C705.6 313.3 705.6 239.6 705.5 165.9C705.5 162.6 706.2 160.6 709.4 158.8C768.2 126.6 826.9 94.2 885.6 61.9C886.3 61.6 887.1 61.3 888.7 60.5Z"
														fill=""
													/>
												</svg>
											</div>
										</HashLink>
									</div>
								)}
								{MyRoleOpener && (
									<div className="w-full h-full flex items-start justify-start pt-10 pl-10 flex-col gap-3">
										<HashLink
											smooth
											className="text-black  group relative cursor-pointer   hover:text-lime-500   text-center transition-all duration-75 text-xl ease-in"
											to="/"
										>
											CEO
										</HashLink>
										<HashLink
											smooth
											className="text-black  group relative cursor-pointer   hover:text-lime-500   text-center transition-all duration-75 text-xl ease-in"
											to="/"
										>
											Founder
										</HashLink>
										<HashLink
											smooth
											className="text-black  group relative cursor-pointer   hover:text-lime-500   text-center transition-all duration-75 text-xl ease-in"
											to="/"
										>
											Head of Sales
										</HashLink>
										<HashLink
											smooth
											className="text-black  group relative cursor-pointer   hover:text-lime-500   text-center transition-all duration-75 text-xl ease-in"
											to="/"
										>
											Head of Marketing
										</HashLink>
									</div>
								)}
								{MyGrowthStageOpener && (
									<div className="w-full h-full flex items-start justify-start pt-10 pl-10 flex-col gap-3">
										<HashLink
											smooth
											className="text-black  group relative cursor-pointer   hover:text-lime-500   text-center transition-all duration-75 text-xl ease-in"
											to="/"
										>
											Launch My Company
										</HashLink>
										<HashLink
											smooth
											className="text-black  group relative cursor-pointer   hover:text-lime-500   text-center transition-all duration-75 text-xl ease-in"
											to="/"
										>
											Go To Market
										</HashLink>
										<HashLink
											smooth
											className="text-black  group relative cursor-pointer   hover:text-lime-500   text-center transition-all duration-75 text-xl ease-in"
											to="/"
										>
											Branding Re-Fresh
										</HashLink>
										<HashLink
											smooth
											className="text-black  group relative cursor-pointer   hover:text-lime-500   text-center transition-all duration-75 text-xl ease-in"
											to="/"
										>
											Take Me to the Next Level
										</HashLink>
										<HashLink
											smooth
											className="text-black  group relative cursor-pointer   hover:text-lime-500   text-center transition-all duration-75 text-xl ease-in"
											to="/"
										>
											Expand My Team
										</HashLink>
									</div>
								)}
							</div>
							<div
								// onMouseEnter={() => {
								// 	setExploreMenu(false);
								// 	setMyGrowthStageOpener(false);
								// 	setMyRoleOpener(false);
								// }}
								className="w-full h-full border-r border-l  relative overflow-hidden"
							>
								{MyRoleOpener && !MyGrowthStageOpener && (
									<div className="w-full h-full   relative overflow-hidden">
										<HashLink
											smooth
											className="cursor-pointer relative w-full h-full   group    text-white font-semibold     text-base ease-in"
											to={"/lobby"}
										>
											<div className="w-full h-full bg-gradient-to-t from-black/90 via-transparent absolute"></div>

											<img
												src={SearchNavImageTwo}
												className="w-full h-full object-cover  "
												alt=""
											/>
											<div className="flex items-center absolute bottom-[30px] left-[35%] transition-all duration-200  group justify-start gap-2">
												<p className=" transition-all group-hover:text-lime-500 duration-200  ease-in cursor-pointer">
													Virtual Lobby
												</p>

												<svg
													width="23"
													height="15"
													viewBox="0 0 889 553"
													className=" fill-white group-hover:fill-lime-500 transition-all duration-200  ease-in"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M0.199951 275.8C0.199951 217.4 -0.100049 159 0.399951 100.6C0.499951 88.6004 2.39995 76.4004 4.99995 64.6004C12.3 31.2004 33.7 11.2004 66.8 4.60041C80.6 1.80041 94.8 0.300415 108.9 0.300415C190.2 0.00041455 271.4 0.300415 352.7 0.400415C388.1 0.300415 423.6 0.000414543 459 0.000414543C491.8 0.000414543 524.6 -0.299585 557.4 0.500415C570.1 0.800415 583 2.60041 595.4 5.40041C629.2 13.0004 648.9 34.9004 655.4 68.5004C657.7 80.5004 659.2 92.9004 659.2 105.1C659.5 209.3 659.6 313.5 659.4 417.6C659.4 437.8 659 458.3 656.3 478.3C650.6 519.4 626.4 543 585.3 549.3C573 551.2 560.5 552.3 548 552.3C479.2 552.5 410.5 552.3 341.7 552.2C294.4 552.1 247.2 552.1 199.9 552.1C167.9 552.1 136 552.6 104 551.9C90.5 551.6 76.7 549.7 63.5 546.7C30.0999 539.1 10.6 517.3 4.19995 484.1C1.69995 471.3 0.299951 458 0.199951 445C-0.200049 388.6 -4.88274e-05 332.2 -4.88274e-05 275.8C0.0999512 275.8 0.199951 275.8 0.199951 275.8Z"
														fill=""
													/>
													<path
														d="M888.7 60.5C888.7 204.4 888.7 347.6 888.7 491.4C887.1 490.7 885.8 490.3 884.6 489.6C826.6 458.3 768.7 427 710.7 395.9C706.7 393.8 705.5 391.3 705.5 387C705.6 313.3 705.6 239.6 705.5 165.9C705.5 162.6 706.2 160.6 709.4 158.8C768.2 126.6 826.9 94.2 885.6 61.9C886.3 61.6 887.1 61.3 888.7 60.5Z"
														fill=""
													/>
												</svg>
											</div>
										</HashLink>
									</div>
								)}
								{MyGrowthStageOpener && !MyRoleOpener && (
									<div className="w-full h-full   relative overflow-hidden">
										<HashLink
											smooth
											className="cursor-pointer relative w-full h-full   group    text-white font-semibold     text-base ease-in"
											to={"/lobby"}
										>
											<div className="w-full h-full bg-gradient-to-t from-black/90 via-transparent absolute"></div>

											<img
												src={SearchNavImageTwo}
												className="w-full h-full object-cover  "
												alt=""
											/>
											<div className="flex items-center absolute bottom-[30px] left-[35%] transition-all duration-200  group justify-start gap-2">
												<p className=" transition-all group-hover:text-lime-500 duration-200  ease-in cursor-pointer">
													Virtual Lobby
												</p>

												<svg
													width="23"
													height="15"
													viewBox="0 0 889 553"
													className=" fill-white group-hover:fill-lime-500 transition-all duration-200  ease-in"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M0.199951 275.8C0.199951 217.4 -0.100049 159 0.399951 100.6C0.499951 88.6004 2.39995 76.4004 4.99995 64.6004C12.3 31.2004 33.7 11.2004 66.8 4.60041C80.6 1.80041 94.8 0.300415 108.9 0.300415C190.2 0.00041455 271.4 0.300415 352.7 0.400415C388.1 0.300415 423.6 0.000414543 459 0.000414543C491.8 0.000414543 524.6 -0.299585 557.4 0.500415C570.1 0.800415 583 2.60041 595.4 5.40041C629.2 13.0004 648.9 34.9004 655.4 68.5004C657.7 80.5004 659.2 92.9004 659.2 105.1C659.5 209.3 659.6 313.5 659.4 417.6C659.4 437.8 659 458.3 656.3 478.3C650.6 519.4 626.4 543 585.3 549.3C573 551.2 560.5 552.3 548 552.3C479.2 552.5 410.5 552.3 341.7 552.2C294.4 552.1 247.2 552.1 199.9 552.1C167.9 552.1 136 552.6 104 551.9C90.5 551.6 76.7 549.7 63.5 546.7C30.0999 539.1 10.6 517.3 4.19995 484.1C1.69995 471.3 0.299951 458 0.199951 445C-0.200049 388.6 -4.88274e-05 332.2 -4.88274e-05 275.8C0.0999512 275.8 0.199951 275.8 0.199951 275.8Z"
														fill=""
													/>
													<path
														d="M888.7 60.5C888.7 204.4 888.7 347.6 888.7 491.4C887.1 490.7 885.8 490.3 884.6 489.6C826.6 458.3 768.7 427 710.7 395.9C706.7 393.8 705.5 391.3 705.5 387C705.6 313.3 705.6 239.6 705.5 165.9C705.5 162.6 706.2 160.6 709.4 158.8C768.2 126.6 826.9 94.2 885.6 61.9C886.3 61.6 887.1 61.3 888.7 60.5Z"
														fill=""
													/>
												</svg>
											</div>
										</HashLink>
									</div>
								)}
								{!MyRoleOpener && !MyGrowthStageOpener && (
									<div className="w-full h-full relative overflow-hidden">
										<HashLink
											smooth
											className="cursor-pointer relative flex w-full h-full items-center justify-center gap-3  group   text-black font-semibold    transition-all duration-200 text-base ease-in"
											onClick={() => {
												setRecources(true);
												setSearchMenuOpen(false);
											}}
											to="/#Resources"
										>
											<div className="w-full h-full bg-gradient-to-t from-black/90 z-30 via-transparent absolute"></div>
											<img
												src={SearchNavImageThree}
												className="w-full h-full object-cover z-0  "
												alt=""
											/>
											<div className="bottom-[30px]  absolute z-40 left-[30%] flex items-center justify-center gap-2">
												<p className=" transition-all text-white group-hover:text-lime-500 duration-200  ease-in cursor-pointer">
													Resource Center
												</p>
												<svg
													className="transition-all fill-white group-hover:fill-lime-500 duration-200  ease-in cursor-pointer"
													width="23"
													height="18"
													viewBox="0 0 25 23"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														fillRule="evenodd"
														clipRule="evenodd"
														d="M0.125 3.34375C0.125 1.4987 1.78184 0.25 3.5 0.25H21.5C23.2182 0.25 24.875 1.4987 24.875 3.34375V7.28125C24.875 9.1263 23.2182 10.375 21.5 10.375H3.5C1.78184 10.375 0.125 9.1263 0.125 7.28125V3.34375ZM6.875 5.3125C6.875 6.24448 6.11948 7 5.1875 7C4.25552 7 3.5 6.24448 3.5 5.3125C3.5 4.38052 4.25552 3.625 5.1875 3.625C6.11948 3.625 6.875 4.38052 6.875 5.3125Z"
														fill=""
													/>
													<path
														fillRule="evenodd"
														clipRule="evenodd"
														d="M0.125 15.7188C0.125 13.8737 1.78184 12.625 3.5 12.625H21.5C23.2182 12.625 24.875 13.8737 24.875 15.7188V19.6562C24.875 21.5013 23.2182 22.75 21.5 22.75H3.5C1.78184 22.75 0.125 21.5013 0.125 19.6562V15.7188ZM6.875 17.6875C6.875 18.6195 6.11948 19.375 5.1875 19.375C4.25552 19.375 3.5 18.6195 3.5 17.6875C3.5 16.7555 4.25552 16 5.1875 16C6.11948 16 6.875 16.7555 6.875 17.6875Z"
														fill=""
													/>
												</svg>
											</div>
										</HashLink>
									</div>
								)}
							</div>

							<div className="w-full h-full  relative overflow-hidden">
								{MyRoleOpener ||
									(MyGrowthStageOpener && (
										<div className="w-full h-full relative overflow-hidden">
											<HashLink
												smooth
												className="cursor-pointer relative flex w-full h-full items-center justify-center gap-3  group   text-black font-semibold    transition-all duration-200 text-base ease-in"
												onClick={() => {
													setRecources(true);
													setSearchMenuOpen(false);
												}}
												to="/#Resources"
											>
												<div className="w-full h-full bg-gradient-to-t from-black/90 z-30 via-transparent absolute"></div>
												<img
													src={SearchNavImageThree}
													className="w-full h-full object-cover z-0  "
													alt=""
												/>
												<div className="bottom-[30px]  absolute z-40 left-[30%] flex items-center justify-center gap-2">
													<p className=" transition-all text-white group-hover:text-lime-500 duration-200  ease-in cursor-pointer">
														Resource Center
													</p>
													<svg
														className="transition-all fill-white group-hover:fill-lime-500 duration-200  ease-in cursor-pointer"
														width="23"
														height="18"
														viewBox="0 0 25 23"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															fillRule="evenodd"
															clipRule="evenodd"
															d="M0.125 3.34375C0.125 1.4987 1.78184 0.25 3.5 0.25H21.5C23.2182 0.25 24.875 1.4987 24.875 3.34375V7.28125C24.875 9.1263 23.2182 10.375 21.5 10.375H3.5C1.78184 10.375 0.125 9.1263 0.125 7.28125V3.34375ZM6.875 5.3125C6.875 6.24448 6.11948 7 5.1875 7C4.25552 7 3.5 6.24448 3.5 5.3125C3.5 4.38052 4.25552 3.625 5.1875 3.625C6.11948 3.625 6.875 4.38052 6.875 5.3125Z"
															fill=""
														/>
														<path
															fillRule="evenodd"
															clipRule="evenodd"
															d="M0.125 15.7188C0.125 13.8737 1.78184 12.625 3.5 12.625H21.5C23.2182 12.625 24.875 13.8737 24.875 15.7188V19.6562C24.875 21.5013 23.2182 22.75 21.5 22.75H3.5C1.78184 22.75 0.125 21.5013 0.125 19.6562V15.7188ZM6.875 17.6875C6.875 18.6195 6.11948 19.375 5.1875 19.375C4.25552 19.375 3.5 18.6195 3.5 17.6875C3.5 16.7555 4.25552 16 5.1875 16C6.11948 16 6.875 16.7555 6.875 17.6875Z"
															fill=""
														/>
													</svg>
												</div>
											</HashLink>
										</div>
									))}
								{MyGrowthStageOpener ||
									(MyRoleOpener && (
										<div className="w-full h-full  overflow-hidden">
											<HashLink
												smooth
												className="cursor-pointer relative flex w-full h-full items-center justify-center gap-3  group   text-black font-semibold    transition-all duration-200 text-base ease-in"
												onClick={() => {
													setRecources(true);
													setSearchMenuOpen(false);
												}}
												to="/#Resources"
											>
												<div className="w-full h-full bg-gradient-to-t from-black/90 z-30 via-transparent absolute"></div>
												<img
													src={SearchNavImageThree}
													className="w-full h-full object-cover z-0  "
													alt=""
												/>
												<div className="bottom-[30px]  absolute z-40 left-[30%] flex items-center justify-center gap-2">
													<p className=" transition-all text-white group-hover:text-lime-500 duration-200  ease-in cursor-pointer">
														Resource Center
													</p>
													<svg
														className="transition-all fill-white group-hover:fill-lime-500 duration-200  ease-in cursor-pointer"
														width="23"
														height="18"
														viewBox="0 0 25 23"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															fillRule="evenodd"
															clipRule="evenodd"
															d="M0.125 3.34375C0.125 1.4987 1.78184 0.25 3.5 0.25H21.5C23.2182 0.25 24.875 1.4987 24.875 3.34375V7.28125C24.875 9.1263 23.2182 10.375 21.5 10.375H3.5C1.78184 10.375 0.125 9.1263 0.125 7.28125V3.34375ZM6.875 5.3125C6.875 6.24448 6.11948 7 5.1875 7C4.25552 7 3.5 6.24448 3.5 5.3125C3.5 4.38052 4.25552 3.625 5.1875 3.625C6.11948 3.625 6.875 4.38052 6.875 5.3125Z"
															fill=""
														/>
														<path
															fillRule="evenodd"
															clipRule="evenodd"
															d="M0.125 15.7188C0.125 13.8737 1.78184 12.625 3.5 12.625H21.5C23.2182 12.625 24.875 13.8737 24.875 15.7188V19.6562C24.875 21.5013 23.2182 22.75 21.5 22.75H3.5C1.78184 22.75 0.125 21.5013 0.125 19.6562V15.7188ZM6.875 17.6875C6.875 18.6195 6.11948 19.375 5.1875 19.375C4.25552 19.375 3.5 18.6195 3.5 17.6875C3.5 16.7555 4.25552 16 5.1875 16C6.11948 16 6.875 16.7555 6.875 17.6875Z"
															fill=""
														/>
													</svg>
												</div>
											</HashLink>
										</div>
									))}
								{!MyRoleOpener && !MyGrowthStageOpener && (
									<div className="w-full h-full group cursor-pointer  overflow-hidden">
										<HashLink
											smooth
											className="cursor-pointer relative   "
											to={"/about"}
										>
											<div className="w-full h-full bg-gradient-to-t z-30 from-black/90 via-transparent absolute"></div>

											<img
												src={SearchNavImageOne}
												className="w-full h-full object-cover z-0   "
												alt=""
											/>
											<div className="flex text-white hover:text-lime-500 bottom-[30px]   font-semibold  left-[35%]  text-base  items-center absolute  group-hover:text-lime-500 transition-all duration-200 ease-in justify-start z-50  gap-2">
												About Us
												<svg
													className="transition-all fill-white group-hover:fill-lime-500 duration-200  ease-in cursor-pointer"
													width="20"
													height="20"
													viewBox="0 0 25 25"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														fillRule="evenodd"
														clipRule="evenodd"
														d="M25 12.5C25 19.4035 19.4035 25 12.5 25C5.59643 25 0 19.4035 0 12.5C0 5.59643 5.59643 0 12.5 0C19.4035 0 25 5.59643 25 12.5ZM12.5 19.6875C13.0177 19.6875 13.4375 19.2678 13.4375 18.75V11.25C13.4375 10.7322 13.0177 10.3125 12.5 10.3125C11.9822 10.3125 11.5625 10.7322 11.5625 11.25V18.75C11.5625 19.2678 11.9822 19.6875 12.5 19.6875ZM12.5 6.24999C13.1903 6.24999 13.75 6.80964 13.75 7.49999C13.75 8.19033 13.1903 8.74998 12.5 8.74998C11.8096 8.74998 11.25 8.19033 11.25 7.49999C11.25 6.80964 11.8096 6.24999 12.5 6.24999Z"
														fill=""
													/>
												</svg>
											</div>
										</HashLink>
									</div>
								)}
							</div>
						</div>
					)}
				</div>
			)}
			{/* Logo Is Here  */}
			<div className=" xl:w-1/3 w-full    h-full flex  items-center xl:justify-center ">
				<HashLink
					smooth
					className="hover:text-lime-400 group relative cursor-pointer transition-all duration-75 text-base ease-in"
					to="/#landingPage"
				>
					<div className="relative flex flex-col items-center justify-center gap-1">
						<svg
							className={`${
								isScrolled
									? " transition-all   z-[9999]"
									: " -mt-2 transition-all  z-[9999]"
							} transition-all  duration-300 ease-in `}
							width="178"
							height="31"
							viewBox="0 0 188 31"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M9.35867 22.9785C11.4875 22.9785 12.5533 22.3715 12.5533 21.0777C12.5533 20.0518 10.8035 19.2139 7.34105 18.6041C2.89253 17.7919 0.609854 15.8142 0.569957 12.6566C0.569957 8.31922 3.9897 6.26452 8.59783 6.19043C11.1835 6.19043 13.2372 6.76039 14.759 7.9003C16.2447 9.08011 17.0436 10.7159 17.1558 12.8077H13.9639C12.7842 12.7706 12.0232 12.3517 11.7183 11.5537C11.3763 10.6788 10.3504 10.183 8.67475 10.183C6.69415 10.183 5.69957 10.7244 5.69957 11.7447C5.69957 12.7649 6.99337 13.5685 9.618 14.0644C13.0378 14.7483 15.2863 15.6232 16.3891 16.652C16.8481 17.1252 17.2087 17.6847 17.4504 18.298C17.692 18.9114 17.8098 19.5665 17.7969 20.2257C17.7969 25.1728 13.9155 26.9967 8.59208 26.9967C5.78222 26.9967 3.65342 26.3982 2.27982 25.2099C0.758043 24.07 0 22.3173 0 19.9977H5.17236C5.28635 22.2034 6.88223 22.9642 9.35867 22.9642"
								fill="white"
							/>
							<path
								d="M25.2207 11.7447H20.1623C20.7693 8.01715 23.3939 6.19043 28.0363 6.19043C33.5904 6.19043 36.4032 8.01715 36.5172 11.7447V18.5842C36.5172 24.1384 33.1715 26.612 27.7313 26.991C22.8867 27.3729 19.5524 25.1272 19.5524 20.6759C19.6636 15.8541 23.1659 14.5574 28.2642 14.0644C30.4329 13.7965 31.5358 13.1525 31.5358 12.0467C31.4218 10.9068 30.3559 10.3368 28.2642 10.3368C26.4745 10.3368 25.4857 10.7928 25.2207 11.7447ZM31.6098 18.3618V16.4981C30.3095 17.034 28.9598 17.4415 27.5803 17.715C25.5626 18.0968 24.5367 19.0487 24.5367 20.5306C24.6507 22.1292 25.4857 22.8902 27.0844 22.8902C29.9 22.8902 31.6098 21.2145 31.6098 18.3618Z"
								fill="white"
							/>
							<path
								d="M44.7732 3.22362V26.6175H39.7119V0.75H42.3366C42.9852 0.762642 43.6032 1.02847 44.0585 1.49068C44.5138 1.95289 44.7702 2.57483 44.7732 3.22362Z"
								fill="white"
							/>
							<path
								d="M56.603 27.0737C50.5159 26.8827 47.4838 23.3462 47.4838 16.4981C47.4838 9.65008 50.5672 6.23888 56.6914 6.19043C63.0806 6.19043 66.0957 10.1089 65.7053 17.9828H52.6846C52.8755 21.0635 54.2064 22.6223 56.6743 22.6223C57.8513 22.6223 58.9541 22.1292 59.9458 21.1775C60.1613 20.9399 60.4258 20.7521 60.721 20.6271C61.0163 20.5021 61.3353 20.4429 61.6558 20.4536H65.3833C64.2803 24.7283 61.5418 27.0737 56.5974 27.0737M52.7615 14.3693H60.3306C60.0257 11.7047 58.7718 10.3368 56.603 10.3368C54.4343 10.3368 53.1406 11.7047 52.7615 14.3693Z"
								fill="white"
							/>
							<path
								d="M76.8396 22.9779C78.9713 22.9779 80.0342 22.3709 80.0342 21.0772C80.0342 20.0513 78.2844 19.2133 74.8248 18.6035C70.3734 17.8056 68.0908 15.8278 68.0537 12.6703C68.0537 8.33289 71.4734 6.2782 76.0787 6.2041C78.6663 6.2041 80.721 6.77406 82.2428 7.91398C83.725 9.09375 84.5233 10.7296 84.6392 12.8213H81.442C80.265 12.7843 79.5041 12.3653 79.1992 11.5674C78.8573 10.6925 77.8284 10.1967 76.1557 10.1967C74.1779 10.1967 73.189 10.7296 73.189 11.7583C73.189 12.7871 74.4828 13.5822 77.1074 14.0781C80.5272 14.762 82.7757 15.6369 83.8783 16.6657C84.3367 17.1393 84.6975 17.6988 84.9392 18.312C85.1809 18.9253 85.2984 19.5803 85.2867 20.2393C85.2867 25.1865 81.4049 27.0104 76.0787 27.0104C73.2631 27.0104 71.1343 26.4034 69.7636 25.2236C68.2418 24.0837 67.4838 22.331 67.4838 20.0113H72.6703C72.7843 22.2171 74.3802 22.9779 76.8539 22.9779"
								fill="white"
							/>
							<path
								d="M87.4883 14.7854V26.6177H92.6175V13.7595C92.655 11.6677 93.795 10.6418 96.0375 10.6418C98.28 10.6418 99.4233 11.6677 99.5375 13.7595V26.6177H104.635V13.8364C104.672 11.7447 105.815 10.7017 108.055 10.7017C110.295 10.7017 111.441 11.7304 111.555 13.8364V24.184C111.555 25.7798 112.392 26.5778 114.065 26.6918H116.69V14.8623C116.727 9.12 113.874 6.26452 108.141 6.26452C105.553 6.26452 103.581 6.79744 102.13 7.9003C100.682 6.76039 98.7108 6.19043 96.12 6.19043C90.375 6.19043 87.485 9.04021 87.485 14.7854"
								fill="url(#paint0_linear_2570_1989)"
							/>
							<path
								d="M129.982 6.49512C123.247 6.49512 119.785 9.72676 119.634 16.2328V26.6174H124.763V16.1559C124.763 13.2263 126.171 11.7444 128.987 11.7444H130.697V6.49512H129.982Z"
								fill="url(#paint1_linear_2570_1989)"
							/>
							<path
								d="M151.626 0.75V22.7361C151.588 24.9818 152.5 26.1558 154.401 26.3497C156.171 26.5331 157.955 26.5465 159.728 26.3895V22.548H158.163C157.174 22.548 156.678 22.0892 156.678 21.2542V10.1087H157.211C157.543 10.1161 157.874 10.056 158.183 9.932C158.493 9.80792 158.773 9.62258 159.008 9.38717C159.243 9.15167 159.428 8.87099 159.552 8.56202C159.675 8.25304 159.735 7.9222 159.728 7.58948V6.49517H156.684V3.29771C156.684 1.96686 155.581 0.75 154.25 0.75H151.626Z"
								fill="url(#paint2_linear_2570_1989)"
							/>
							<path
								d="M133.057 0.77832V26.6458H138.117V19.3048C138.098 19.069 138.17 18.8347 138.319 18.6506C138.467 18.4664 138.681 18.3466 138.916 18.3159C139.563 18.3159 140.211 18.8858 140.857 20.0258L144.43 26.6458H150.517L143.481 14.7138L150.44 7.24449H144.356L142.102 9.82925L139.417 12.907L138.117 14.3974V3.25194C138.115 2.60315 137.858 1.98121 137.403 1.519C136.948 1.05679 136.33 0.790962 135.682 0.77832H133.057Z"
								fill="url(#paint3_linear_2570_1989)"
							/>
							<path
								d="M164.7 22.54C164.887 22.2133 165.16 21.9467 165.52 21.74C165.88 21.5333 166.29 21.43 166.75 21.43C167.243 21.43 167.687 21.5467 168.08 21.78C168.473 22.0133 168.783 22.3433 169.01 22.77C169.237 23.19 169.35 23.68 169.35 24.24C169.35 24.7933 169.237 25.2867 169.01 25.72C168.783 26.1533 168.47 26.49 168.07 26.73C167.677 26.97 167.237 27.09 166.75 27.09C166.277 27.09 165.86 26.9867 165.5 26.78C165.147 26.5733 164.88 26.31 164.7 25.99V27H163.79V19.6H164.7V22.54ZM168.42 24.24C168.42 23.8267 168.337 23.4667 168.17 23.16C168.003 22.8533 167.777 22.62 167.49 22.46C167.21 22.3 166.9 22.22 166.56 22.22C166.227 22.22 165.917 22.3033 165.63 22.47C165.35 22.63 165.123 22.8667 164.95 23.18C164.783 23.4867 164.7 23.8433 164.7 24.25C164.7 24.6633 164.783 25.0267 164.95 25.34C165.123 25.6467 165.35 25.8833 165.63 26.05C165.917 26.21 166.227 26.29 166.56 26.29C166.9 26.29 167.21 26.21 167.49 26.05C167.777 25.8833 168.003 25.6467 168.17 25.34C168.337 25.0267 168.42 24.66 168.42 24.24ZM175.548 24.05C175.548 24.2233 175.538 24.4067 175.518 24.6H171.138C171.171 25.14 171.354 25.5633 171.688 25.87C172.028 26.17 172.438 26.32 172.918 26.32C173.311 26.32 173.638 26.23 173.898 26.05C174.164 25.8633 174.351 25.6167 174.458 25.31H175.438C175.291 25.8367 174.998 26.2667 174.558 26.6C174.118 26.9267 173.571 27.09 172.918 27.09C172.398 27.09 171.931 26.9733 171.518 26.74C171.111 26.5067 170.791 26.1767 170.558 25.75C170.324 25.3167 170.208 24.8167 170.208 24.25C170.208 23.6833 170.321 23.1867 170.548 22.76C170.774 22.3333 171.091 22.0067 171.498 21.78C171.911 21.5467 172.384 21.43 172.918 21.43C173.438 21.43 173.898 21.5433 174.298 21.77C174.698 21.9967 175.004 22.31 175.218 22.71C175.438 23.1033 175.548 23.55 175.548 24.05ZM174.608 23.86C174.608 23.5133 174.531 23.2167 174.378 22.97C174.224 22.7167 174.014 22.5267 173.748 22.4C173.488 22.2667 173.198 22.2 172.878 22.2C172.418 22.2 172.024 22.3467 171.698 22.64C171.378 22.9333 171.194 23.34 171.148 23.86H174.608ZM177.859 22.27V25.5C177.859 25.7667 177.916 25.9567 178.029 26.07C178.142 26.1767 178.339 26.23 178.619 26.23H179.289V27H178.469C177.962 27 177.582 26.8833 177.329 26.65C177.076 26.4167 176.949 26.0333 176.949 25.5V22.27H176.239V21.52H176.949V20.14H177.859V21.52H179.289V22.27H177.859ZM180.052 24.24C180.052 23.68 180.165 23.19 180.392 22.77C180.618 22.3433 180.928 22.0133 181.322 21.78C181.722 21.5467 182.165 21.43 182.652 21.43C183.132 21.43 183.548 21.5333 183.902 21.74C184.255 21.9467 184.518 22.2067 184.692 22.52V21.52H185.612V27H184.692V25.98C184.512 26.3 184.242 26.5667 183.882 26.78C183.528 26.9867 183.115 27.09 182.642 27.09C182.155 27.09 181.715 26.97 181.322 26.73C180.928 26.49 180.618 26.1533 180.392 25.72C180.165 25.2867 180.052 24.7933 180.052 24.24ZM184.692 24.25C184.692 23.8367 184.608 23.4767 184.442 23.17C184.275 22.8633 184.048 22.63 183.762 22.47C183.482 22.3033 183.172 22.22 182.832 22.22C182.492 22.22 182.182 22.3 181.902 22.46C181.622 22.62 181.398 22.8533 181.232 23.16C181.065 23.4667 180.982 23.8267 180.982 24.24C180.982 24.66 181.065 25.0267 181.232 25.34C181.398 25.6467 181.622 25.8833 181.902 26.05C182.182 26.21 182.492 26.29 182.832 26.29C183.172 26.29 183.482 26.21 183.762 26.05C184.048 25.8833 184.275 25.6467 184.442 25.34C184.608 25.0267 184.692 24.6633 184.692 24.25Z"
								fill="white"
							/>
							<defs>
								<linearGradient
									id="paint0_linear_2570_1989"
									x1="102.096"
									y1="26.7772"
									x2="102.096"
									y2="0.0747893"
									gradientUnits="userSpaceOnUse"
								>
									<stop stopColor="#3BB54A" />
									<stop offset="0.06" stopColor="#4EBA47" />
									<stop offset="0.17" stopColor="#70C242" />
									<stop offset="0.3" stopColor="#8CC93E" />
									<stop offset="0.43" stopColor="#A1CE3A" />
									<stop offset="0.58" stopColor="#B0D238" />
									<stop offset="0.75" stopColor="#B9D436" />
									<stop offset="1" stopColor="#BCD536" />
								</linearGradient>
								<linearGradient
									id="paint1_linear_2570_1989"
									x1="125.168"
									y1="26.777"
									x2="125.168"
									y2="0.0745503"
									gradientUnits="userSpaceOnUse"
								>
									<stop stopColor="#3BB54A" />
									<stop offset="0.06" stopColor="#4EBA47" />
									<stop offset="0.17" stopColor="#70C242" />
									<stop offset="0.3" stopColor="#8CC93E" />
									<stop offset="0.43" stopColor="#A1CE3A" />
									<stop offset="0.58" stopColor="#B0D238" />
									<stop offset="0.75" stopColor="#B9D436" />
									<stop offset="1" stopColor="#BCD536" />
								</linearGradient>
								<linearGradient
									id="paint2_linear_2570_1989"
									x1="155.675"
									y1="26.7771"
									x2="155.675"
									y2="0.0746016"
									gradientUnits="userSpaceOnUse"
								>
									<stop stopColor="#3BB54A" />
									<stop offset="0.06" stopColor="#4EBA47" />
									<stop offset="0.17" stopColor="#70C242" />
									<stop offset="0.3" stopColor="#8CC93E" />
									<stop offset="0.43" stopColor="#A1CE3A" />
									<stop offset="0.58" stopColor="#B0D238" />
									<stop offset="0.75" stopColor="#B9D436" />
									<stop offset="1" stopColor="#BCD536" />
								</linearGradient>
								<linearGradient
									id="paint3_linear_2570_1989"
									x1="141.788"
									y1="26.7769"
									x2="141.788"
									y2="0.0744225"
									gradientUnits="userSpaceOnUse"
								>
									<stop stopColor="#3BB54A" />
									<stop offset="0.06" stopColor="#4EBA47" />
									<stop offset="0.17" stopColor="#70C242" />
									<stop offset="0.3" stopColor="#8CC93E" />
									<stop offset="0.43" stopColor="#A1CE3A" />
									<stop offset="0.58" stopColor="#B0D238" />
									<stop offset="0.75" stopColor="#B9D436" />
									<stop offset="1" stopColor="#BCD536" />
								</linearGradient>
							</defs>
						</svg>
						<svg
							className={`${
								isScrolled
									? " scale-90 opacity-0 bottom-0  z-[99]"
									: "scale-100 bottom-[-14px]  z-[99]"
							} transition-all absolute   duration-200 ease-in `}
							width="133"
							height="10"
							viewBox="0 0 133 10"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M12.936 0.554401L10.362 9.768H8.184L6.4548 3.2076L4.6464 9.768L2.4816 9.7812L0 0.554401H1.98L3.6036 7.7088L5.478 0.554401H7.5372L9.306 7.6692L10.9428 0.554401H12.936ZM18.2611 2.3496C18.8155 2.3496 19.3083 2.4728 19.7395 2.7192C20.1707 2.9568 20.5051 3.3132 20.7427 3.7884C20.9891 4.2548 21.1123 4.818 21.1123 5.478V9.768H19.2643V5.7288C19.2643 5.148 19.1191 4.7036 18.8287 4.3956C18.5383 4.0788 18.1423 3.9204 17.6407 3.9204C17.1303 3.9204 16.7255 4.0788 16.4263 4.3956C16.1359 4.7036 15.9907 5.148 15.9907 5.7288V9.768H14.1427V0H15.9907V3.366C16.2283 3.0492 16.5451 2.8028 16.9411 2.6268C17.3371 2.442 17.7771 2.3496 18.2611 2.3496ZM29.6676 5.9532C29.6676 6.2172 29.65 6.4548 29.6148 6.666H24.2688C24.3128 7.194 24.4976 7.6076 24.8232 7.9068C25.1488 8.206 25.5492 8.3556 26.0244 8.3556C26.7108 8.3556 27.1992 8.0608 27.4896 7.4712H29.4828C29.2716 8.1752 28.8668 8.756 28.2684 9.2136C27.67 9.6624 26.9352 9.8868 26.064 9.8868C25.36 9.8868 24.7264 9.7328 24.1632 9.4248C23.6088 9.108 23.1732 8.6636 22.8564 8.0916C22.5484 7.5196 22.3944 6.8596 22.3944 6.1116C22.3944 5.3548 22.5484 4.6904 22.8564 4.1184C23.1644 3.5464 23.5956 3.1064 24.15 2.7984C24.7044 2.4904 25.3424 2.3364 26.064 2.3364C26.7592 2.3364 27.3796 2.486 27.9252 2.7852C28.4796 3.0844 28.9064 3.5112 29.2056 4.0656C29.5136 4.6112 29.6676 5.2404 29.6676 5.9532ZM27.7536 5.4252C27.7448 4.95 27.5732 4.5716 27.2388 4.29C26.9044 3.9996 26.4952 3.8544 26.0112 3.8544C25.5536 3.8544 25.1664 3.9952 24.8496 4.2768C24.5416 4.5496 24.3524 4.9324 24.282 5.4252H27.7536ZM32.8645 3.5904C33.1021 3.2032 33.4101 2.8996 33.7885 2.6796C34.1757 2.4596 34.6157 2.3496 35.1085 2.3496V4.29H34.6201C34.0393 4.29 33.5993 4.4264 33.3001 4.6992C33.0097 4.972 32.8645 5.4472 32.8645 6.1248V9.768H31.0165V2.4552H32.8645V3.5904ZM43.1512 5.9532C43.1512 6.2172 43.1336 6.4548 43.0984 6.666H37.7524C37.7964 7.194 37.9812 7.6076 38.3068 7.9068C38.6324 8.206 39.0328 8.3556 39.508 8.3556C40.1944 8.3556 40.6828 8.0608 40.9732 7.4712H42.9664C42.7552 8.1752 42.3504 8.756 41.752 9.2136C41.1536 9.6624 40.4188 9.8868 39.5476 9.8868C38.8436 9.8868 38.21 9.7328 37.6468 9.4248C37.0924 9.108 36.6568 8.6636 36.34 8.0916C36.032 7.5196 35.878 6.8596 35.878 6.1116C35.878 5.3548 36.032 4.6904 36.34 4.1184C36.648 3.5464 37.0792 3.1064 37.6336 2.7984C38.188 2.4904 38.826 2.3364 39.5476 2.3364C40.2428 2.3364 40.8632 2.486 41.4088 2.7852C41.9632 3.0844 42.39 3.5112 42.6892 4.0656C42.9972 4.6112 43.1512 5.2404 43.1512 5.9532ZM41.2372 5.4252C41.2284 4.95 41.0568 4.5716 40.7224 4.29C40.388 3.9996 39.9788 3.8544 39.4948 3.8544C39.0372 3.8544 38.65 3.9952 38.3332 4.2768C38.0252 4.5496 37.836 4.9324 37.7656 5.4252H41.2372ZM52.8726 5.0424C53.3918 5.1392 53.8186 5.3988 54.153 5.8212C54.4874 6.2436 54.6546 6.7276 54.6546 7.2732C54.6546 7.766 54.5314 8.2016 54.285 8.58C54.0474 8.9496 53.6998 9.24 53.2422 9.4512C52.7846 9.6624 52.2434 9.768 51.6186 9.768H47.6454V0.554401H51.447C52.0718 0.554401 52.6086 0.655602 53.0574 0.858002C53.515 1.0604 53.8582 1.342 54.087 1.7028C54.3246 2.0636 54.4434 2.4728 54.4434 2.9304C54.4434 3.4672 54.2982 3.916 54.0078 4.2768C53.7262 4.6376 53.3478 4.8928 52.8726 5.0424ZM49.4934 4.356H51.183C51.623 4.356 51.9618 4.2592 52.1994 4.0656C52.437 3.8632 52.5558 3.5772 52.5558 3.2076C52.5558 2.838 52.437 2.552 52.1994 2.3496C51.9618 2.1472 51.623 2.046 51.183 2.046H49.4934V4.356ZM51.3546 8.2632C51.8034 8.2632 52.151 8.1576 52.3974 7.9464C52.6526 7.7352 52.7802 7.436 52.7802 7.0488C52.7802 6.6528 52.6482 6.3448 52.3842 6.1248C52.1202 5.896 51.7638 5.7816 51.315 5.7816H49.4934V8.2632H51.3546ZM57.9754 3.5904C58.213 3.2032 58.521 2.8996 58.8994 2.6796C59.2866 2.4596 59.7266 2.3496 60.2194 2.3496V4.29H59.731C59.1502 4.29 58.7102 4.4264 58.411 4.6992C58.1206 4.972 57.9754 5.4472 57.9754 6.1248V9.768H56.1274V2.4552H57.9754V3.5904ZM60.9889 6.0852C60.9889 5.346 61.1341 4.6904 61.4245 4.1184C61.7237 3.5464 62.1241 3.1064 62.6257 2.7984C63.1361 2.4904 63.7037 2.3364 64.3285 2.3364C64.8741 2.3364 65.3493 2.4464 65.7541 2.6664C66.1677 2.8864 66.4977 3.1636 66.7441 3.498V2.4552H68.6053V9.768H66.7441V8.6988C66.5065 9.042 66.1765 9.328 65.7541 9.5568C65.3405 9.7768 64.8609 9.8868 64.3153 9.8868C63.6993 9.8868 63.1361 9.7284 62.6257 9.4116C62.1241 9.0948 61.7237 8.6504 61.4245 8.0784C61.1341 7.4976 60.9889 6.8332 60.9889 6.0852ZM66.7441 6.1116C66.7441 5.6628 66.6561 5.28 66.4801 4.9632C66.3041 4.6376 66.0665 4.3912 65.7673 4.224C65.4681 4.048 65.1469 3.96 64.8037 3.96C64.4605 3.96 64.1437 4.0436 63.8533 4.2108C63.5629 4.378 63.3253 4.6244 63.1405 4.95C62.9645 5.2668 62.8765 5.6452 62.8765 6.0852C62.8765 6.5252 62.9645 6.9124 63.1405 7.2468C63.3253 7.5724 63.5629 7.8232 63.8533 7.9992C64.1525 8.1752 64.4693 8.2632 64.8037 8.2632C65.1469 8.2632 65.4681 8.1796 65.7673 8.0124C66.0665 7.8364 66.3041 7.59 66.4801 7.2732C66.6561 6.9476 66.7441 6.5604 66.7441 6.1116ZM74.4631 2.3496C75.3341 2.3496 76.0381 2.6268 76.5751 3.1812C77.1111 3.7268 77.3801 4.4924 77.3801 5.478V9.768H75.5321V5.7288C75.5321 5.148 75.3871 4.7036 75.0961 4.3956C74.8061 4.0788 74.4101 3.9204 73.9081 3.9204C73.3981 3.9204 72.9931 4.0788 72.6941 4.3956C72.4031 4.7036 72.2581 5.148 72.2581 5.7288V9.768H70.4101V2.4552H72.2581V3.366C72.5051 3.0492 72.8171 2.8028 73.1951 2.6268C73.5831 2.442 74.0051 2.3496 74.4631 2.3496ZM78.6621 6.0852C78.6621 5.346 78.8071 4.6904 79.0971 4.1184C79.3971 3.5464 79.8011 3.1064 80.3121 2.7984C80.8221 2.4904 81.3901 2.3364 82.0151 2.3364C82.4901 2.3364 82.9431 2.442 83.3741 2.6532C83.8051 2.8556 84.1491 3.1284 84.4041 3.4716V0H86.2781V9.768H84.4041V8.6856C84.1751 9.0464 83.8541 9.3368 83.4401 9.5568C83.0271 9.7768 82.5471 9.8868 82.0011 9.8868C81.3851 9.8868 80.8221 9.7284 80.3121 9.4116C79.8011 9.0948 79.3971 8.6504 79.0971 8.0784C78.8071 7.4976 78.6621 6.8332 78.6621 6.0852ZM84.4171 6.1116C84.4171 5.6628 84.3291 5.28 84.1531 4.9632C83.9771 4.6376 83.7391 4.3912 83.4401 4.224C83.1411 4.048 82.8201 3.96 82.4771 3.96C82.1331 3.96 81.8171 4.0436 81.5261 4.2108C81.2361 4.378 80.9981 4.6244 80.8131 4.95C80.6371 5.2668 80.5491 5.6452 80.5491 6.0852C80.5491 6.5252 80.6371 6.9124 80.8131 7.2468C80.9981 7.5724 81.2361 7.8232 81.5261 7.9992C81.8251 8.1752 82.1421 8.2632 82.4771 8.2632C82.8201 8.2632 83.1411 8.1796 83.4401 8.0124C83.7391 7.8364 83.9771 7.59 84.1531 7.2732C84.3291 6.9476 84.4171 6.5604 84.4171 6.1116ZM90.8821 9.8868C90.2831 9.8868 89.7461 9.7812 89.2711 9.57C88.7961 9.35 88.4181 9.0552 88.1361 8.6856C87.8631 8.316 87.7141 7.9068 87.6871 7.458H89.5481C89.5841 7.7396 89.7201 7.9728 89.9581 8.1576C90.2041 8.3424 90.5081 8.4348 90.8681 8.4348C91.2201 8.4348 91.4931 8.3644 91.6871 8.2236C91.8891 8.0828 91.9901 7.9024 91.9901 7.6824C91.9901 7.4448 91.8671 7.2688 91.6211 7.1544C91.3831 7.0312 91.0001 6.8992 90.4721 6.7584C89.9271 6.6264 89.4781 6.49 89.1261 6.3492C88.7831 6.2084 88.4841 5.9928 88.2281 5.7024C87.9821 5.412 87.8591 5.0204 87.8591 4.5276C87.8591 4.1228 87.9731 3.7532 88.2021 3.4188C88.4401 3.0844 88.7741 2.8204 89.2051 2.6268C89.6451 2.4332 90.1601 2.3364 90.7501 2.3364C91.6211 2.3364 92.3161 2.5564 92.8351 2.9964C93.3541 3.4276 93.6401 4.0128 93.6931 4.752H91.9241C91.8981 4.4616 91.7751 4.2328 91.5551 4.0656C91.3441 3.8896 91.0581 3.8016 90.6971 3.8016C90.3621 3.8016 90.1031 3.8632 89.9181 3.9864C89.7421 4.1096 89.6541 4.2812 89.6541 4.5012C89.6541 4.7476 89.7771 4.9368 90.0241 5.0688C90.2701 5.192 90.6531 5.3196 91.1721 5.4516C91.7001 5.5836 92.1361 5.72 92.4791 5.8608C92.8221 6.0016 93.1171 6.2216 93.3631 6.5208C93.6181 6.8112 93.7501 7.1984 93.7591 7.6824C93.7591 8.1048 93.6401 8.4832 93.4031 8.8176C93.1741 9.152 92.8401 9.416 92.4001 9.6096C91.9681 9.7944 91.4621 9.8868 90.8821 9.8868ZM104.837 3.3264C104.625 2.9392 104.335 2.6444 103.965 2.442C103.596 2.2396 103.165 2.1384 102.672 2.1384C102.126 2.1384 101.642 2.2616 101.22 2.508C100.797 2.7544 100.467 3.1064 100.23 3.564C99.9921 4.0216 99.8731 4.5496 99.8731 5.148C99.8731 5.764 99.9921 6.3008 100.23 6.7584C100.476 7.216 100.815 7.568 101.246 7.8144C101.677 8.0608 102.179 8.184 102.751 8.184C103.455 8.184 104.031 7.9992 104.48 7.6296C104.929 7.2512 105.224 6.7276 105.365 6.0588H102.197V4.6464H107.186V6.2568C107.063 6.8992 106.799 7.4932 106.394 8.0388C105.989 8.5844 105.466 9.0244 104.823 9.3588C104.19 9.6844 103.477 9.8472 102.685 9.8472C101.796 9.8472 100.991 9.6492 100.269 9.2532C99.5571 8.8484 98.9931 8.2896 98.5801 7.5768C98.1751 6.864 97.9731 6.0544 97.9731 5.148C97.9731 4.2416 98.1751 3.432 98.5801 2.7192C98.9931 1.9976 99.5571 1.4388 100.269 1.0428C100.991 0.638001 101.792 0.4356 102.672 0.4356C103.71 0.4356 104.612 0.690802 105.378 1.2012C106.143 1.7028 106.671 2.4112 106.962 3.3264H104.837ZM110.401 3.5904C110.639 3.2032 110.947 2.8996 111.325 2.6796C111.713 2.4596 112.153 2.3496 112.645 2.3496V4.29H112.157C111.576 4.29 111.136 4.4264 110.837 4.6992C110.547 4.972 110.401 5.4472 110.401 6.1248V9.768H108.553V2.4552H110.401V3.5904ZM117.137 9.8868C116.433 9.8868 115.8 9.7328 115.237 9.4248C114.673 9.108 114.229 8.6636 113.903 8.0916C113.587 7.5196 113.428 6.8596 113.428 6.1116C113.428 5.3636 113.591 4.7036 113.917 4.1316C114.251 3.5596 114.704 3.1196 115.276 2.8116C115.848 2.4948 116.486 2.3364 117.19 2.3364C117.894 2.3364 118.532 2.4948 119.104 2.8116C119.676 3.1196 120.125 3.5596 120.451 4.1316C120.785 4.7036 120.952 5.3636 120.952 6.1116C120.952 6.8596 120.781 7.5196 120.437 8.0916C120.103 8.6636 119.645 9.108 119.065 9.4248C118.493 9.7328 117.85 9.8868 117.137 9.8868ZM117.137 8.2764C117.472 8.2764 117.784 8.1972 118.075 8.0388C118.374 7.8716 118.611 7.6252 118.787 7.2996C118.963 6.974 119.051 6.578 119.051 6.1116C119.051 5.4164 118.867 4.884 118.497 4.5144C118.136 4.136 117.692 3.9468 117.164 3.9468C116.636 3.9468 116.191 4.136 115.831 4.5144C115.479 4.884 115.303 5.4164 115.303 6.1116C115.303 6.8068 115.474 7.3436 115.817 7.722C116.169 8.0916 116.609 8.2764 117.137 8.2764ZM132.445 2.4552L130.307 9.768H128.314L126.981 4.6596L125.647 9.768H123.641L121.489 2.4552H123.364L124.657 8.0256L126.057 2.4552H128.01L129.383 8.0124L130.677 2.4552H132.445Z"
								fill="white"
							/>
						</svg>
					</div>
				</HashLink>
			</div>
			{isWideScreen && (
				<div className=" h-full relative w-1/3 hidden xl:flex items-center justify-around   gap-0 ">
					{/* <InvestMenu /> */}
					<div className="flex items-center justify-end gap-6 pr-6 xl:gap-6 w-full xl:pr-16 ">
						<div className="relative">
							<div
								onMouseEnter={() => {
									setSolutionsMenuOpen(false);
									setSearchMenuOpen(false);
									setmembershipMenuOpen(true);
									setAccountMenuShow(false);
									setshoppingMenuShow(false);
									setLetsTalkMenu(false);
								}}
								className="w-fit "
							>
								<HashLink
									smooth
									className="hover:text-lime-400 group relative cursor-pointer transition-all duration-75 text-base ease-in"
									onClick={() => {
										setOne(false);
										setTwo(true);
										setThree(false);
										setFour(false);
										setmembershipMenuOpen(false);
									}}
									to="/"
								>
									Members
								</HashLink>
							</div>
							{membershipMenuOpen && (
								<div
									onMouseLeave={() => {
										setmembershipMenuOpen(false);
									}}
									className="w-[100vw] h-[400px] absolute top-[53px] rounded-b-lg shadow-lg right-[-210px] bg-white grid grid-cols-4 items-start   "
								>
									<div className="w-full flex flex-col   gap-3 bg-white items-center relative justify-center h-full ">
										{/* <h3 className=' w-full opacity-0   pl-12'>
										Launch Benefits{' '}
									</h3> */}
										<HashLink
											className="w-full mt-2  flex items-center justify-center"
											onClick={() => {
												setOne(false);
												setTwo(true);
												setThree(false);
												setFour(false);
												setmembershipMenuOpen(false);
											}}
											to="/"
										>
											<img
												src={CardOne}
												alt="Membership Card"
												className="w-[85%] object-cover hover:scale-[1.02] transition-all duration-300 ease-in-out cursor-pointer"
											/>
										</HashLink>

										<div className="w-full pl-12  xl:text-sm 2xl:text-base">
											<h4 className="text-black">
												<span className="font-semibold mr-1">Launch:</span>
												Trial a membership & receive
											</h4>{" "}
											<h4 className="text-black mb-6">
												5% discount on all your purchases
											</h4>{" "}
										</div>
									</div>
									<div className="w-full flex flex-col gap-3 bg-white items-center relative justify-center h-full ">
										<div className="w-[85%]  flex items-center  justify-between">
											{/* <h3 className='text-white opacity-0  w-full  '>
											Growth Benefits{' '}
										</h3>
										<svg
											width='87'
											height='27'
											viewBox='0 0 87 27'
											fill='none'
											xmlns='http://www.w3.org/2000/svg'>
											<rect
												width='86.6235'
												height='26.1562'
												rx='13.0781'
												fill='#3BB54A'
											/>
											<path
												d='M14.8332 14.5692C14.8332 13.6722 14.1572 13.1262 13.1692 13.1262H11.2192V15.9472H13.2212C14.2222 15.9472 14.8332 15.4403 14.8332 14.5692ZM14.5992 10.6302C14.5992 9.81125 14.0142 9.33025 13.0522 9.33025H11.2192V11.9172H13.0522C14.0142 11.9172 14.5992 11.4622 14.5992 10.6302ZM16.3152 14.7252C16.3152 16.1032 15.1972 17.1562 13.3512 17.1562H9.73721V8.12125H13.1822C15.0932 8.12125 16.1072 9.17425 16.1072 10.4482C16.1072 11.5402 15.4442 12.2032 14.5732 12.5152C15.5352 12.6842 16.3152 13.6462 16.3152 14.7252ZM20.9417 11.1242C19.9407 11.1242 19.1347 11.8002 18.9787 12.9312H22.9437C22.9177 11.8262 22.0467 11.1242 20.9417 11.1242ZM24.2957 15.0242C23.8927 16.2722 22.7617 17.2733 21.0067 17.2733C18.9527 17.2733 17.4317 15.8172 17.4317 13.5682C17.4317 11.3192 18.8877 9.87625 21.0067 9.87625C23.0477 9.87625 24.4907 11.2932 24.4907 13.3992C24.4907 13.6462 24.4777 13.8802 24.4387 14.1272H18.9657C19.0697 15.3102 19.9147 16.0252 21.0067 16.0252C21.9167 16.0252 22.4237 15.5832 22.6967 15.0242H24.2957ZM31.2921 15.1542C31.2921 16.3632 30.2391 17.2733 28.5491 17.2733C26.8331 17.2733 25.6241 16.2592 25.5591 14.9592H27.0931C27.1451 15.5442 27.7041 16.0252 28.5231 16.0252C29.3811 16.0252 29.8361 15.6612 29.8361 15.1672C29.8361 13.7632 25.6761 14.5692 25.6761 11.9432C25.6761 10.7992 26.7421 9.87625 28.4321 9.87625C30.0571 9.87625 31.1231 10.7472 31.2011 12.1772H29.7191C29.6671 11.5532 29.1861 11.1242 28.3801 11.1242C27.5871 11.1242 27.1711 11.4492 27.1711 11.9302C27.1711 13.3732 31.2141 12.5672 31.2921 15.1542ZM33.1275 15.1672V11.2022H32.2825V9.99325H33.1275V8.21225H34.6225V9.99325H36.3645V11.2022H34.6225V15.1672C34.6225 15.7002 34.8305 15.9212 35.4545 15.9212H36.3645V17.1562H35.1945C33.9205 17.1562 33.1275 16.6232 33.1275 15.1672ZM44.6433 15.6352L47.3343 8.12125H48.8943L45.5013 17.1562H43.7853L40.3793 8.12125H41.9653L44.6433 15.6352ZM49.6397 13.5422C49.6397 11.3322 51.1347 9.87625 53.0197 9.87625C54.2287 9.87625 55.0607 10.4482 55.5027 11.0332V9.99325H56.9977V17.1562H55.5027V16.0902C55.0477 16.7012 54.1897 17.2733 52.9937 17.2733C51.1347 17.2733 49.6397 15.7522 49.6397 13.5422ZM55.5027 13.5682C55.5027 12.0342 54.4497 11.1632 53.3317 11.1632C52.2267 11.1632 51.1607 11.9952 51.1607 13.5422C51.1607 15.0892 52.2267 15.9862 53.3317 15.9862C54.4497 15.9862 55.5027 15.1152 55.5027 13.5682ZM58.9442 17.1562V7.53625H60.4262V17.1562H58.9442ZM68.859 9.99325V17.1562H67.377V16.2983C66.909 16.9092 66.103 17.2603 65.258 17.2603C63.581 17.2603 62.307 16.2072 62.307 14.2052V9.99325H63.776V13.9842C63.776 15.2972 64.491 15.9732 65.57 15.9732C66.662 15.9732 67.377 15.2972 67.377 13.9842V9.99325H68.859ZM73.8304 11.1242C72.8294 11.1242 72.0234 11.8002 71.8674 12.9312H75.8324C75.8064 11.8262 74.9354 11.1242 73.8304 11.1242ZM77.1844 15.0242C76.7814 16.2722 75.6504 17.2733 73.8954 17.2733C71.8414 17.2733 70.3204 15.8172 70.3204 13.5682C70.3204 11.3192 71.7764 9.87625 73.8954 9.87625C75.9364 9.87625 77.3794 11.2932 77.3794 13.3992C77.3794 13.6462 77.3664 13.8802 77.3274 14.1272H71.8544C71.9584 15.3102 72.8034 16.0252 73.8954 16.0252C74.8054 16.0252 75.3124 15.5832 75.5854 15.0242H77.1844Z'
												fill='white'
											/>
										</svg> */}
										</div>
										<HashLink
											className="w-full  flex items-center justify-center"
											onClick={() => {
												setOne(false);
												setTwo(true);
												setThree(false);
												setFour(false);
												setmembershipMenuOpen(false);
											}}
											to="/"
										>
											<img
												src={CardTwo}
												alt="Membership Card"
												className="w-[85%] object-cover hover:scale-[1.02] transition-all duration-300 ease-in-out cursor-pointer "
											/>
										</HashLink>

										<div className="w-full pl-12 xl:text-sm 2xl:text-base">
											<h4 className="text-black">
												<span className="font-semibold mr-1">Growth:</span>
												Enjoy the best value to build
											</h4>{" "}
											<h4 className="text-black mb-6">
												your brand & grow your revenues
											</h4>{" "}
										</div>
									</div>
									<div className="w-full flex flex-col gap-3 bg-white items-center relative justify-center h-full ">
										<div className="w-[85%]  flex items-center justify-between">
											{/* <h3 className='text-white opacity-0 w-full  '>
											Enterprise Benefits
										</h3>
										<svg
											width='87'
											height='27'
											viewBox='0 0 87 27'
											fill='none'
											xmlns='http://www.w3.org/2000/svg'>
											<rect
												width='86.6235'
												height='26.1562'
												rx='13.0781'
												fill='#3BB54A'
											/>
											<path
												d='M18.0226 9.33025V8.12125H24.3276V9.33025H21.9226V17.1562H20.4406V9.33025H18.0226ZM32.6535 13.5682C32.6535 15.8172 30.9895 17.2733 28.9355 17.2733C26.8945 17.2733 25.3475 15.8172 25.3475 13.5682C25.3475 11.3192 26.9595 9.87625 29.0005 9.87625C31.0415 9.87625 32.6535 11.3192 32.6535 13.5682ZM26.8555 13.5682C26.8555 15.1932 27.8175 15.9862 28.9355 15.9862C30.0405 15.9862 31.1325 15.1932 31.1325 13.5682C31.1325 11.9432 30.0795 11.1632 28.9745 11.1632C27.8565 11.1632 26.8555 11.9432 26.8555 13.5682ZM35.6006 11.0462C36.0556 10.4482 36.9266 9.87625 38.0966 9.87625C39.9816 9.87625 41.4636 11.3322 41.4636 13.5422C41.4636 15.7522 39.9816 17.2733 38.0966 17.2733C36.9136 17.2733 36.0686 16.6752 35.6006 16.1162V20.5623H34.1186V9.99325H35.6006V11.0462ZM39.9556 13.5422C39.9556 11.9952 38.8896 11.1632 37.7716 11.1632C36.6666 11.1632 35.6006 12.0342 35.6006 13.5682C35.6006 15.1152 36.6666 15.9862 37.7716 15.9862C38.8896 15.9862 39.9556 15.0892 39.9556 13.5422ZM45.8381 9.33025V8.12125H52.1431V9.33025H49.7381V17.1562H48.2561V9.33025H45.8381ZM53.6439 17.1562V9.99325H55.1259V17.1562H53.6439ZM54.3979 9.04425C53.8649 9.04425 53.4489 8.62825 53.4489 8.09525C53.4489 7.56225 53.8649 7.14625 54.3979 7.14625C54.9179 7.14625 55.3339 7.56225 55.3339 8.09525C55.3339 8.62825 54.9179 9.04425 54.3979 9.04425ZM60.0877 11.1242C59.0867 11.1242 58.2807 11.8002 58.1247 12.9312H62.0897C62.0637 11.8262 61.1927 11.1242 60.0877 11.1242ZM63.4417 15.0242C63.0387 16.2722 61.9077 17.2733 60.1527 17.2733C58.0987 17.2733 56.5777 15.8172 56.5777 13.5682C56.5777 11.3192 58.0337 9.87625 60.1527 9.87625C62.1937 9.87625 63.6367 11.2932 63.6367 13.3992C63.6367 13.6462 63.6237 13.8802 63.5847 14.1272H58.1117C58.2157 15.3102 59.0607 16.0252 60.1527 16.0252C61.0627 16.0252 61.5697 15.5832 61.8427 15.0242H63.4417ZM66.5771 13.3862V17.1562H65.0951V9.99325H66.5771V11.0332C66.9931 10.3182 67.7081 9.87625 68.7221 9.87625V11.4102H68.3451C67.2531 11.4102 66.5771 11.8652 66.5771 13.3862Z'
												fill='white'
											/>
										</svg> */}
										</div>
										<HashLink
											className="w-full  flex items-center justify-center"
											onClick={() => {
												setOne(false);
												setTwo(true);
												setThree(false);
												setFour(false);
												setmembershipMenuOpen(false);
											}}
											to="/"
										>
											<img
												src={CardThree}
												alt="Membership Card"
												className="w-[85%] object-cover hover:scale-[1.02] transition-all duration-300 ease-in-out cursor-pointer "
											/>
										</HashLink>
										<div className="w-full pl-12 xl:text-sm 2xl:text-base">
											<h4 className="text-black">
												<span className="font-semibold mr-1">Enterprise:</span>{" "}
												Leverage benefits, savings
											</h4>{" "}
											<h4 className="text-black mb-6">
												& incentives across your full enterprise
											</h4>{" "}
										</div>
									</div>

									<div className="  w-full h-full flex flex-col items-start pl-10 pr-10 pt-10 justify-start gap-6 ">
										<HashLink to={"/lobby"}>
											<div className="flex items-center justify-between gap-3 group cursor-pointer">
												<p className="text-black group-hover:text-lime-500 transition-all duration-150 ease-in">
													Membership Sign Up
												</p>
												<div>
													<svg
														className="fill-black group-hover:fill-lime-500 transition-all duration-150 ease-in"
														fill="#"
														height="20px"
														width="20px"
														version="1.1"
														id="Capa_1"
														viewBox="0 0 499.1 499.1"
													>
														<g>
															<g>
																<g>
																	<path
																		d="M0,249.6c0,9.5,7.7,17.2,17.2,17.2h327.6l-63.9,63.8c-6.7,6.7-6.7,17.6,0,24.3c3.3,3.3,7.7,5,12.1,5s8.8-1.7,12.1-5
				l93.1-93.1c6.7-6.7,6.7-17.6,0-24.3l-93.1-93.1c-6.7-6.7-17.6-6.7-24.3,0c-6.7,6.7-6.7,17.6,0,24.3l63.8,63.8H17.2
				C7.7,232.5,0,240.1,0,249.6z"
																	/>
																	<path
																		d="M396.4,494.2c56.7,0,102.7-46.1,102.7-102.8V107.7C499.1,51,453,4.9,396.4,4.9H112.7C56,4.9,10,51,10,107.7V166
				c0,9.5,7.7,17.1,17.1,17.1c9.5,0,17.2-7.7,17.2-17.1v-58.3c0-37.7,30.7-68.5,68.4-68.5h283.7c37.7,0,68.4,30.7,68.4,68.5v283.7
				c0,37.7-30.7,68.5-68.4,68.5H112.7c-37.7,0-68.4-30.7-68.4-68.5v-57.6c0-9.5-7.7-17.2-17.2-17.2S10,324.3,10,333.8v57.6
				c0,56.7,46.1,102.8,102.7,102.8H396.4L396.4,494.2z"
																	/>
																</g>
															</g>
															<g></g>
															<g></g>
															<g></g>
															<g></g>
															<g></g>
															<g></g>
															<g></g>
															<g></g>
															<g></g>
															<g></g>
															<g></g>
															<g></g>
															<g></g>
															<g></g>
															<g></g>
														</g>
													</svg>
												</div>
											</div>
										</HashLink>
										<div className="w-full h-[1px] border-b"></div>
										<HashLink
											smooth
											className="text-black group  transition-all flex items-center gap-3 cursor-pointer"
											onClick={() => {
												setRecources(true);
												setmembershipMenuOpen(false);
											}}
											to="/#Resources"
										>
											<p className="transition-all text-black group-hover:text-lime-500 duration-200 ease-in">
												Resource Center
											</p>
											<div>
												<svg
													className="group-hover:stroke-lime-500 stroke-black transition-all duration-200 ease-in"
													width="23"
													height="21"
													viewBox="0 0 26 23"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M0.75 3.22106C0.75 1.81688 2.03575 0.75 3.52841 0.75H22.3466C23.8393 0.75 25.125 1.81687 25.125 3.22106V7.3206C25.125 8.72479 23.8393 9.79166 22.3466 9.79166H3.52841C2.03575 9.79166 0.75 8.72478 0.75 7.3206V3.22106Z"
														stroke=""
														stroke-width="1.5"
													/>
													<circle
														cx="5.27083"
														cy="5.27083"
														r="2.39583"
														fill="black"
													/>
													<circle
														cx="5.27083"
														cy="5.27083"
														r="2.39583"
														fill="black"
													/>
													<path
														d="M0.75 15.6794C0.75 14.2753 2.03575 13.2084 3.52841 13.2084H22.3466C23.8393 13.2084 25.125 14.2752 25.125 15.6794V19.779C25.125 21.1832 23.8393 22.25 22.3466 22.25H3.52841C2.03575 22.25 0.75 21.1832 0.75 19.779V15.6794Z"
														stroke=""
														stroke-width="1.5"
													/>
													<circle
														cx="5.27083"
														cy="17.7292"
														r="2.39583"
														fill="black"
													/>
													<circle
														cx="5.27083"
														cy="17.7292"
														r="2.39583"
														fill="black"
													/>
												</svg>
											</div>
										</HashLink>
										{/* <div className='w-full h-[1px] border-b'></div> */}
										{/* <div></div> */}
										{/* <HashLink
											smooth
											className='text-black hover:text-lime-500  transition-all cursor-pointer '
											onClick={() => {
												setOne(false);
												setTwo(true);
												setThree(false);
												setFour(false);
												setmembershipMenuOpen(false);
											}}
											to='/'>
											Enjoy incentives inside.
										</HashLink> */}

										{/* <HashLink
										smooth
										className='text-black hover:text-lime-500 group relative cursor-pointer transition-all duration-100 text-xl ease-in'
										onClick={() => {
											setOne(false);
											setTwo(false);
											setThree(false);
											setFour(true);
										}}
										to='/#Experience'>
										Experience
									</HashLink> */}
										{/* <HashLink
										smooth
										className='text-black group hover:text-lime-500 relative cursor-pointer transition-all duration-100 text-xl ease-in'
										onClick={() => {
											setRecources(true);
										}}
										to='/#Resources'>
										Resources
									</HashLink> */}
									</div>
								</div>
							)}
						</div>
						<div className="w-fit relative">
							<a
								onMouseEnter={() => {
									setLetsTalkMenu(true);
									setSolutionsMenuOpen(false);
									setSearchMenuOpen(false);
									setmembershipMenuOpen(false);
									setAccountMenuShow(false);
									setshoppingMenuShow(false);
								}}
								href="https://calendly.com/salesbox-meet/salesmrkt"
								target="_blank"
								rel="noopener noreferrer"
							>
								<span className="flex items-center     transition-all duration-100 ease-in cursor-pointer    justify-center gap-2 ">
									<h5 className="text-base hover:text-lime-400 transition-all mt-[2px] duration-100 ease-in  ">
										Let's Talk
									</h5>
									{/* <FaCalendar className='h-[17px] w-[17px] text-[#6DC939]' /> */}
								</span>
							</a>
							{letsTalkMenu && (
								<div
									onMouseLeave={() => {
										setLetsTalkMenu(false);
									}}
									className="w-[380px] h-[400px] bg-white absolute flex flex-col    pl-10 pr-16 items-start pt-10   gap-6 top-[53px] left-[-167px] rounded-b-lg shadow-xl"
								>
									<div className="flex items-center group justify-between w-full">
										<HashLink to={"/lobby"} className="w-full">
											<div className="w-full flex items-center justify-start gap-3">
												<p
													className="text-black group-hover:text-lime-500 transition-all duration-150 ease-in"
													rel="noopener noreferrer"
												>
													Live Meeting
												</p>
												<BsPersonVideo className="text-black  group-hover:text-lime-500  text-lg transition-all duration-100 ease-in" />
											</div>
										</HashLink>
									</div>

									<div className="w-full h-[1px] border-b "></div>
									<div className="flex group items-center justify-start gap-3 w-full">
										<a
											href="https://calendly.com/salesbox-meet/salesmrkt"
											target="_blank"
											className="text-black group-hover:text-lime-500 transition-all duration-150 ease-in"
											rel="noopener noreferrer"
										>
											Schedule an Appointment
										</a>
										<AiOutlineCalendar className="text-black  group-hover:text-lime-500  text-lg transition-all duration-100 ease-in" />
									</div>
									<div className="w-full h-[1px] border-b "></div>
									<div
										onClick={(e) => {
											e.stopPropagation();
											setInfoSenderOpen(true);
											setLetsTalkMenu(false);
										}}
										className="flex cursor-pointer items-center group justify-start gap-3 w-full"
									>
										<p className="text-black group-hover:text-lime-500 transition-all duration-150 ease-in">
											Send More Info
										</p>
										<BsInfoCircle className="text-black  group-hover:text-lime-500  text-lg transition-all duration-100 ease-in" />
									</div>
									<div className="w-full h-[1px] border-b "></div>
									<p
										onClick={() => copyToClipboard(phoneNumber)}
										className="flex cursor-pointer items-center gap-3 group text-black hover:text-lime-500 transition-all duration-100 ease-in"
									>
										1-888-920-GROW
										<div>
											<svg
												className="group-hover:stroke-lime-500 stroke-black transition-all duration-100 ease-in"
												width="17"
												height="17"
												viewBox="0 0 17 17"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													d="M10.5833 3.91667C11.1976 4.03652 11.8074 4.30744 12.25 4.75001C12.6925 5.19257 12.9635 5.80238 13.0833 6.41668M11 1C12.2762 1.14178 13.4247 1.75923 14.3333 2.66667C15.2419 3.57411 15.8565 4.72392 16 6.00001M15.9995 12.2306V14.4887C16.003 15.3519 15.2269 16.0728 14.3554 15.9941C6.83337 16 0.999996 10.1125 1.00589 2.641C0.927396 1.77413 1.64465 1.00088 2.50675 1.00007H4.76937C5.13539 0.996475 5.49024 1.12583 5.76777 1.36403C6.55677 2.04124 7.06428 4.33982 6.86903 5.25358C6.71657 5.96698 5.99742 6.46609 5.5085 6.95401C6.58215 8.83852 8.14553 10.3988 10.0337 11.4704C10.5226 10.9824 11.0228 10.2647 11.7375 10.1125C12.6545 9.91735 14.9679 10.4255 15.6424 11.22C15.8816 11.5018 16.0087 11.8614 15.9995 12.2306Z"
													stroke=""
													stroke-linecap="round"
													stroke-linejoin="round"
												/>
											</svg>
										</div>
									</p>
								</div>
							)}
						</div>
						{/* Shopping Menu */}
						{/* <span
							onClick={() => {
								handleClick();
							}}
							className='text-white transition-all group relative duration-100   cursor-pointer text-xl'>
							<svg
								onMouseEnter={() => {
									setSolutionsMenuOpen(false);
									setSearchMenuOpen(false);
									setmembershipMenuOpen(false);
									setAccountMenuShow(false);
									setshoppingMenuShow(true);
									setLetsTalkMenu(false);
								}}
								className='h-[18px] fill-white hover:fill-lime-400 transition-all duration-150  w-[18px] mt-[1px]'
								width=''
								height=''
								viewBox='0 0 27 24'
								fill='none'
								xmlns='http://www.w3.org/2000/svg'>
								<path
									d='M24.2341 8.31416H20.0582L14.1177 0.415708C14.0206 0.286635 13.8948 0.181873 13.75 0.109719C13.6053 0.0375644 13.4457 0 13.284 0C13.1222 0 12.9626 0.0375644 12.8179 0.109719C12.6732 0.181873 12.5473 0.286635 12.4502 0.415708L6.50972 8.31416H2.33379C1.77203 8.3133 1.23286 8.53465 0.834536 8.92966C0.436214 9.32468 0.211263 9.8611 0.209021 10.4213C0.207808 10.6193 0.236575 10.8164 0.294351 11.0059L3.30824 21.6025C3.50422 22.2932 3.92102 22.9011 4.49525 23.3339C5.06949 23.7666 5.76975 24.0005 6.48952 24H20.0784C20.7982 23.9978 21.498 23.7634 22.0733 23.3319C22.6486 22.9004 23.0684 22.2949 23.2701 21.6058L26.2879 10.9948C26.3018 10.9446 26.3118 10.8933 26.3179 10.8415L26.3524 10.5213C26.3563 10.4879 26.3583 10.4543 26.3582 10.4206C26.3558 9.86068 26.1309 9.32452 25.7327 8.92966C25.3346 8.53481 24.7957 8.31347 24.2341 8.31416ZM13.284 2.7716L17.4527 8.31416H9.11519L13.284 2.7716Z'
									fill=''
								/>
							</svg>

							{shoppingMenuShow && (
								<div
									onMouseLeave={() => {
										setshoppingMenuShow(false);
									}}
									className='w-[380px] h-[400px] bg-white absolute   right-[-107px] rounded-b-lg shadow-xl top-[49px]'>
									<a
										href='https://calendly.com/salesbox-meet/salesmrkt'
										target='_blank'
										className='w-full h-full flex flex-col gap-1 items-center  justify-center'
										rel='noopener noreferrer'>
										<div className=' mb-3'>
											<svg
												width='50'
												height='49'
												viewBox='0 0 30 35'
												fill='none'
												xmlns='http://www.w3.org/2000/svg'>
												<path
													fillRule='evenodd'
													clipRule='evenodd'
													d='M24.0276 21.3142L24.0251 21.3142L2.12173 21.3142C2.08775 21.3141 2.05625 21.3276 2.03386 21.3498C2.01201 21.3714 2.00051 21.3996 2.00004 21.4279L2.00391 21.4406L5.02329 32.0566C5.1 32.3269 5.26345 32.5659 5.48996 32.7366C5.71658 32.9074 5.99367 33.0002 6.27911 33H19.8656C20.1544 32.9986 20.4345 32.9043 20.6642 32.732C20.8928 32.5605 21.0592 32.321 21.14 32.0496L24.1303 21.5352L24.145 21.3993C24.1397 21.3811 24.1298 21.364 24.1154 21.3498C24.0931 21.3276 24.0616 21.3141 24.0276 21.3142ZM26.1493 21.4206C26.1493 21.4543 26.1473 21.4879 26.1434 21.5213L26.1089 21.8415C26.1028 21.8933 26.0928 21.9446 26.0789 21.9948L23.0611 32.6058C22.8594 33.2949 22.4396 33.9004 21.8643 34.3319C21.2891 34.7634 20.5892 34.9978 19.8694 35H6.28054C5.56076 35.0005 4.86051 34.7666 4.28627 34.3339C3.71203 33.9011 3.29523 33.2932 3.09925 32.6025L0.0853663 22.0059C0.0275909 21.8164 -0.00117629 21.6193 3.68235e-05 21.4213C0.00227836 20.8611 0.22723 20.3247 0.625552 19.9297C1.02387 19.5346 1.56304 19.3133 2.1248 19.3142H6.30073L12.2412 11.4157C12.3251 11.3041 12.4306 11.2107 12.5511 11.1408C12.57 11.1299 12.5893 11.1195 12.6089 11.1097C12.7536 11.0376 12.9132 11 13.075 11C13.2368 11 13.3963 11.0376 13.5411 11.1097C13.5607 11.1195 13.5799 11.1299 13.5988 11.1408C13.7194 11.2107 13.8248 11.3041 13.9087 11.4157L19.8492 19.3142H24.0251C24.5867 19.3135 25.1256 19.5348 25.5237 19.9297C25.9219 20.3245 26.1468 20.8607 26.1493 21.4206ZM8.90621 19.3142L13.075 13.7716L17.2437 19.3142H8.90621Z'
													fill='black'
												/>
												<path
													d='M23.744 8.572C23.744 7.196 23.968 6.124 24.416 5.356C24.864 4.58 25.648 4.192 26.768 4.192C27.88 4.192 28.66 4.58 29.108 5.356C29.556 6.124 29.78 7.196 29.78 8.572C29.78 9.972 29.556 11.06 29.108 11.836C28.66 12.612 27.88 13 26.768 13C25.648 13 24.864 12.612 24.416 11.836C23.968 11.06 23.744 9.972 23.744 8.572ZM28.7 8.572C28.7 7.876 28.652 7.288 28.556 6.808C28.468 6.32 28.28 5.928 27.992 5.632C27.712 5.336 27.304 5.188 26.768 5.188C26.224 5.188 25.808 5.336 25.52 5.632C25.24 5.928 25.052 6.32 24.956 6.808C24.868 7.288 24.824 7.876 24.824 8.572C24.824 9.292 24.868 9.896 24.956 10.384C25.052 10.872 25.24 11.264 25.52 11.56C25.808 11.856 26.224 12.004 26.768 12.004C27.304 12.004 27.712 11.856 27.992 11.56C28.28 11.264 28.468 10.872 28.556 10.384C28.652 9.896 28.7 9.292 28.7 8.572Z'
													fill='black'
												/>
											</svg>
										</div>
										<h3 className='text-black/80  mb-3 '>
											Your cart is empty
										</h3>
										<a
											href='https://calendly.com/salesbox-meet/salesmrkt'
											target='_blank'
											className='relative  flex items-center justify-center'
											rel='noopener noreferrer'>
											<img
												src={CardImageMoney}
												alt=''
												className=' w-[100%]   mt-3 '
											/>
										</a>
										<a
											href='https://calendly.com/salesbox-meet/salesmrkt'
											target='_blank'
											className='text-[#84CC16] mt-3  hover:scale-105 transition-all duration-200 ease-in  '
											rel='noopener noreferrer'>
											Get Started {'>'}
										</a>
									</a>
								</div>
							)}
						</span> */}

						<span
							// onClick={() => {
							// 	handleClick();
							// }}
							className="text-white  relative transition-all duration-100   cursor-pointer text-xl"
						>
							<div
								onMouseEnter={() => {
									setAccountMenuShow(true);
									setSolutionsMenuOpen(false);
									setSearchMenuOpen(false);
									setmembershipMenuOpen(false);
									setLetsTalkMenu(false);
									setshoppingMenuShow(false);
								}}
							>
								<RxHamburgerMenu className="hover:text-lime-500 transition-all duration-300 ease-in" />
								{/* <Hamburger
									
									size={22}
									color={
										accountMenuShow ? '#84CC16' : 'white'
									}
								/> */}
							</div>
							{/* <svg
								className='h-[18px] fill-white hover:fill-lime-400 transition-all duration-150  w-[18px] mt-[1px]'
								onMouseEnter={() => {
									setAccountMenuShow(true);
									setSolutionsMenuOpen(false);
									setSearchMenuOpen(false);
									setmembershipMenuOpen(false);
									setLetsTalkMenu(false);
									setshoppingMenuShow(false);
								}}
								width=''
								height=''
								viewBox='0 0 25 24'
								fill='none'
								xmlns='http://www.w3.org/2000/svg'>
								<path
									d='M12.209 12C10.559 12 9.14648 11.4125 7.97148 10.2375C6.79648 9.0625 6.20898 7.65 6.20898 6C6.20898 4.35 6.79648 2.9375 7.97148 1.7625C9.14648 0.5875 10.559 0 12.209 0C13.859 0 15.2715 0.5875 16.4465 1.7625C17.6215 2.9375 18.209 4.35 18.209 6C18.209 7.65 17.6215 9.0625 16.4465 10.2375C15.2715 11.4125 13.859 12 12.209 12ZM3.20898 24C2.38398 24 1.67798 23.7065 1.09098 23.1195C0.502984 22.5315 0.208984 21.825 0.208984 21V19.8C0.208984 18.95 0.427985 18.1685 0.865985 17.4555C1.30298 16.7435 1.88398 16.2 2.60898 15.825C4.15898 15.05 5.73398 14.4685 7.33398 14.0805C8.93398 13.6935 10.559 13.5 12.209 13.5C13.859 13.5 15.484 13.6935 17.084 14.0805C18.684 14.4685 20.259 15.05 21.809 15.825C22.534 16.2 23.115 16.7435 23.552 17.4555C23.99 18.1685 24.209 18.95 24.209 19.8V21C24.209 21.825 23.9155 22.5315 23.3285 23.1195C22.7405 23.7065 22.034 24 21.209 24H3.20898Z'
									fill=''
								/>
							</svg> */}

							{accountMenuShow && (
								<div className="w-[380px] h-[440px] flex flex-col justify-start pt-10 pb-10 pl-16 pr-16 gap-4 bg-white top-[50px] right-[-65px] rounded-b-lg shadow-lg absolute">
									<div
										onClick={() => {
											// setLoginMenuOpener(true);
											window.location.reload();
											setAccountMenuShow(false);
										}}
										onMouseEnter={() => {
											SetAccountHoverIconOne(true);
										}}
										onMouseLeave={() => {
											SetAccountHoverIconOne(false);
										}}
										className="flex items-center justify-start gap-3 "
									>
										<p
											className={`${
												AccountHoverIconOne
													? "text-lime-500  transition-all duration-100 ease-in"
													: " text-black  transition-all duration-100 ease-in"
											}''`}
											rel="noopener noreferrer"
										>
											Login
										</p>

										<CiLogin
											className={`${
												AccountHoverIconOne
													? "text-lime-500  transition-all duration-100 ease-in"
													: " text-black  transition-all duration-100 ease-in"
											}''`}
										/>
									</div>
									<div className="w-full h-[1px] border-b"></div>
									<div className="text-black h-full  flex flex-col justify-between ">
										<HashLink
											className="hover:text-lime-400  transition-all duration-75 ease-in cursor-pointer"
											to={"/about"}
										>
											<div className="flex items-center group gap-3">
												About Us
											</div>
										</HashLink>
										<HashLink smooth className="" to={"/lobby"}>
											<div className="flex items-center  group   gap-3">
												<p className="group-hover:text-lime-500 transition-all duration-200  ease-in cursor-pointer">
													Virtual Lobby
												</p>

												<svg
													width="18"
													height="15"
													viewBox="0 0 889 553"
													className=" fill-black group-hover:fill-lime-500 transition-all duration-200  ease-in"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M0.199951 275.8C0.199951 217.4 -0.100049 159 0.399951 100.6C0.499951 88.6004 2.39995 76.4004 4.99995 64.6004C12.3 31.2004 33.7 11.2004 66.8 4.60041C80.6 1.80041 94.8 0.300415 108.9 0.300415C190.2 0.00041455 271.4 0.300415 352.7 0.400415C388.1 0.300415 423.6 0.000414543 459 0.000414543C491.8 0.000414543 524.6 -0.299585 557.4 0.500415C570.1 0.800415 583 2.60041 595.4 5.40041C629.2 13.0004 648.9 34.9004 655.4 68.5004C657.7 80.5004 659.2 92.9004 659.2 105.1C659.5 209.3 659.6 313.5 659.4 417.6C659.4 437.8 659 458.3 656.3 478.3C650.6 519.4 626.4 543 585.3 549.3C573 551.2 560.5 552.3 548 552.3C479.2 552.5 410.5 552.3 341.7 552.2C294.4 552.1 247.2 552.1 199.9 552.1C167.9 552.1 136 552.6 104 551.9C90.5 551.6 76.7 549.7 63.5 546.7C30.0999 539.1 10.6 517.3 4.19995 484.1C1.69995 471.3 0.299951 458 0.199951 445C-0.200049 388.6 -4.88274e-05 332.2 -4.88274e-05 275.8C0.0999512 275.8 0.199951 275.8 0.199951 275.8Z"
														fill=""
													/>
													<path
														d="M888.7 60.5C888.7 204.4 888.7 347.6 888.7 491.4C887.1 490.7 885.8 490.3 884.6 489.6C826.6 458.3 768.7 427 710.7 395.9C706.7 393.8 705.5 391.3 705.5 387C705.6 313.3 705.6 239.6 705.5 165.9C705.5 162.6 706.2 160.6 709.4 158.8C768.2 126.6 826.9 94.2 885.6 61.9C886.3 61.6 887.1 61.3 888.7 60.5Z"
														fill=""
													/>
												</svg>
											</div>
										</HashLink>

										<HashLink
											smooth
											className="hover:text-lime-400 flex gap-3 group  relative cursor-pointer items-center transition-all duration-75  ease-in"
											to={"/team"}
										>
											<p className="group-hover:text-lime-400 transition-all duration-75 ease-in cursor-pointer">
												Join the Team
											</p>
										</HashLink>
										{/* <HashLink
											smooth
											className='hover:text-lime-400  flex gap-3 group  relative cursor-pointer items-center transition-all duration-75  ease-in'
											to={'/invest'}>
											<p className='group-hover:text-lime-400 transition-all duration-75 ease-in cursor-pointer'>
												Investor Relations
											</p>
										</HashLink> */}

										<div className="group     flex min-w-[300px]  items-center justify-start gap-2  transition-all duration-75 ease-in cursor-pointer">
											<a
												href="https://calendly.com/salesbox-meet/salesmrkt?back=1&month=2023-10"
												target="_blank"
												className="flex items-center justify-center gap-2"
												rel="noopener noreferrer"
											>
												<p className="group-hover:text-lime-400 transition-all duration-75 ease-in">
													Join Partner Program
												</p>
											</a>
										</div>
									</div>

									<div className="w-full h-[1px] border-b"></div>
									<div className="flex items-center  justify-between ">
										<div
											className="w-full"
											onMouseEnter={() => {
												SetAccountHoverIconTwo(true);
											}}
											onMouseLeave={() => {
												SetAccountHoverIconTwo(false);
											}}
										>
											<HashLink
												className="flex w-full items-center justify-start gap-3 "
												to={"/lobby"}
											>
												<p
													className={`${
														AccountHoverIconTwo
															? "text-lime-500  transition-all duration-100 ease-in"
															: " text-black  transition-all duration-100 ease-in"
													}''`}
													rel="noopener noreferrer"
												>
													Live Help
												</p>
												<BiHelpCircle
													className={`${
														AccountHoverIconTwo
															? "text-lime-500  transition-all duration-100 ease-in"
															: " text-black/80  transition-all duration-100 ease-in"
													}''`}
												/>
											</HashLink>
										</div>
									</div>
								</div>
							)}
						</span>
					</div>
				</div>
			)}
			{/* Mobile Menu  */}
			<div className="relative xl:hidden flex">
				<div
					onClick={() => {
						setMainMenuMobile(true);
						setMobileSearch(false);
						setProfileUser(false);
						setCart(false);
					}}
				>
					<Hamburger toggled={isOpend} toggle={setOpend} />
				</div>

				{isOpend && (
					<div className="fixed w-full md:w-[50%] shadow-md  right-[0] p-4 flex items-center justify-center origin-top h-[calc(100vh-80px)] rounded-b-xl z-[999999] bg-white  top-[80px]">
						<div className=" h-full  flex flex-col  w-full items-start justify-start ">
							<div className=" h-full w-full overflow-hidden flex flex-col  ">
								<div className="flex w-full border  justify-between items-center   mt-2 p-3 rounded-lg mb-6">
									{/* {!mainMenuMobile && (

										<span
											onClick={() => {
												setMainMenuMobile(true);
												setMobileSearch(false);
												setProfileUser(false);
												setCart(false)
												
											}}
											className='text-white transition-all group relative duration-100  p-2 rounded-full   cursor-pointer '>
											<AiFillHome className={`${mainMenuMobile ? 'h-[25px] text-lime-500 w-[25px] transition-all duration-200 ease-in':'h-[25px] text-black w-[25px] transition-all duration-200 ease-in'}`} />
										</span>
										)} */}
									<span
										onClick={() => {
											setMainMenuMobile(false);
											setMobileSearch(true);
											setProfileUser(false);
											setCart(false);
										}}
										className="text-white transition-all group relative duration-100  p-2 rounded-full   cursor-pointer "
									>
										<BsSearch
											className={`${
												mobileSearch
													? "h-[25px] text-lime-500 w-[25px] transition-all duration-200 ease-in"
													: "h-[25px] text-black w-[25px] transition-all duration-200 ease-in"
											}`}
										/>
									</span>
									<span
										onClick={() => {
											setMainMenuMobile(false);
											setMobileSearch(false);
											setProfileUser(true);
											setCart(false);
										}}
										className="text-white group relative transition-all duration-100  p-2 rounded-full   cursor-pointer text-xl"
									>
										<svg
											className={`${
												profileUser
													? "h-[25px] fill-lime-500 w-[25px] transition-all duration-200 ease-in"
													: "h-[25px] fill-black w-[25px] transition-all duration-200 ease-in"
											}`}
											width="25"
											height="24"
											viewBox="0 0 25 24"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M12.209 12C10.559 12 9.14648 11.4125 7.97148 10.2375C6.79648 9.0625 6.20898 7.65 6.20898 6C6.20898 4.35 6.79648 2.9375 7.97148 1.7625C9.14648 0.5875 10.559 0 12.209 0C13.859 0 15.2715 0.5875 16.4465 1.7625C17.6215 2.9375 18.209 4.35 18.209 6C18.209 7.65 17.6215 9.0625 16.4465 10.2375C15.2715 11.4125 13.859 12 12.209 12ZM3.20898 24C2.38398 24 1.67798 23.7065 1.09098 23.1195C0.502984 22.5315 0.208984 21.825 0.208984 21V19.8C0.208984 18.95 0.427985 18.1685 0.865985 17.4555C1.30298 16.7435 1.88398 16.2 2.60898 15.825C4.15898 15.05 5.73398 14.4685 7.33398 14.0805C8.93398 13.6935 10.559 13.5 12.209 13.5C13.859 13.5 15.484 13.6935 17.084 14.0805C18.684 14.4685 20.259 15.05 21.809 15.825C22.534 16.2 23.115 16.7435 23.552 17.4555C23.99 18.1685 24.209 18.95 24.209 19.8V21C24.209 21.825 23.9155 22.5315 23.3285 23.1195C22.7405 23.7065 22.034 24 21.209 24H3.20898Z"
												fill=""
											/>
										</svg>
									</span>
									<span
										onClick={() => {
											setMainMenuMobile(false);
											setMobileSearch(false);
											setProfileUser(false);
											setCart(true);
										}}
										className="text-white transition-all group relative duration-100  p-2 rounded-full   cursor-pointer text-xl"
									>
										<svg
											className={`${
												Cart
													? "h-[25px] fill-lime-500 w-[25px] transition-all duration-200 ease-in"
													: "h-[25px] fill-black w-[25px] transition-all duration-200 ease-in"
											}`}
											width="27"
											height="24"
											viewBox="0 0 27 24"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M24.2341 8.31416H20.0582L14.1177 0.415708C14.0206 0.286635 13.8948 0.181873 13.75 0.109719C13.6053 0.0375644 13.4457 0 13.284 0C13.1222 0 12.9626 0.0375644 12.8179 0.109719C12.6732 0.181873 12.5473 0.286635 12.4502 0.415708L6.50972 8.31416H2.33379C1.77203 8.3133 1.23286 8.53465 0.834536 8.92966C0.436214 9.32468 0.211263 9.8611 0.209021 10.4213C0.207808 10.6193 0.236575 10.8164 0.294351 11.0059L3.30824 21.6025C3.50422 22.2932 3.92102 22.9011 4.49525 23.3339C5.06949 23.7666 5.76975 24.0005 6.48952 24H20.0784C20.7982 23.9978 21.498 23.7634 22.0733 23.3319C22.6486 22.9004 23.0684 22.2949 23.2701 21.6058L26.2879 10.9948C26.3018 10.9446 26.3118 10.8933 26.3179 10.8415L26.3524 10.5213C26.3563 10.4879 26.3583 10.4543 26.3582 10.4206C26.3558 9.86068 26.1309 9.32452 25.7327 8.92966C25.3346 8.53481 24.7957 8.31347 24.2341 8.31416ZM13.284 2.7716L17.4527 8.31416H9.11519L13.284 2.7716Z"
												fill=""
											/>
										</svg>
									</span>
								</div>
								{mainMenuMobile && (
									<div className="flex flex-col h-[70%] p-2 justify-between">
										<div>
											<HashLink
												onClick={() => {
													setOpend(false);
												}}
												smooth
												className="text-black font-normal group relative cursor-pointer  transition-all duration-75 text-lg ease-in"
												to="/#Solutions"
											>
												Solutions
											</HashLink>
										</div>
										<div>
											<HashLink
												smooth
												className="text-black font-normal group relative cursor-pointer  transition-all duration-75 text-lg ease-in"
												onClick={() => {
													setTwo(false);
													setOne(true);
													setOpend(false);
												}}
												to="/#Bundles"
											>
												Bundles
											</HashLink>
										</div>
										<div>
											<HashLink
												smooth
												className="text-black font-normal group relative cursor-pointer  transition-all duration-75 text-lg ease-in"
												onClick={() => {
													setExploreButton(true);
													setOpend(false);
												}}
												to="/#Explore"
											>
												Explore
											</HashLink>
										</div>
										<div>
											<HashLink
												smooth
												className="text-black font-normal group relative cursor-pointer  transition-all duration-75 text-lg ease-in"
												onClick={() => {
													setOne(false);
													setTwo(true);
													setOpend(false);
												}}
												to="/"
											>
												Membership
											</HashLink>
										</div>
										<div>
											<HashLink
												smooth
												className="text-black font-normal group relative cursor-pointer  transition-all duration-75 text-lg ease-in"
												onClick={() => {
													setOne(false);
													setTwo(false);
													setThree(false);
													setFour(true);
													setOpend(false);
												}}
												to="/#Experience"
											>
												Experience
											</HashLink>
										</div>
										<div>
											<HashLink
												smooth
												className="text-black font-normal group relative cursor-pointer  transition-all duration-75 text-lg ease-in"
												onClick={() => {
													setRecources(true);
													setOpend(false);
												}}
												to="/#Resources"
											>
												Resources
											</HashLink>
										</div>
									</div>
								)}
								{mobileSearch && (
									<div className="w-full h-full flex flex-col items-start ">
										<input
											type="text"
											name="SearchInput"
											placeholder="Search"
											value={searchTerm}
											onChange={handleSearchChange}
											className={`${
												searchIsEmpty
													? " border-b text-black   p-3 focus-within:outline-none    placeholder-black text-lg  rounded-lg"
													: " border-b text-black  p-3 focus-within:outline-none    placeholder-black text-lg  rounded-lg"
											}' rounded-md w-full mb-6 '`}
											id="Searcher"
											onFocus={(event) => {
												event.target.setAttribute("autocomplete", "off");
											}}
											autoComplete="new-password"
										/>
										{!searchIsEmpty && (
											<div className=" w-full h-full flex flex-col items-start justify-between">
												<ul className="overflow-hidden flex flex-col gap-3 mb-4 ">
													{filteredItems.map((item, index) => (
														<li
															onClick={() => {
																const dictionaryItem = itemDictionary[item];
																if (dictionaryItem) {
																	const { to, onClick } = dictionaryItem;
																	onClick(); // Call the onClick function for the item
																	setmembershipMenuOpen(false);
																	setSearchMenuOpen(false);
																}
															}}
															className="text-black"
															key={index}
														>
															{itemDictionary[item] ? (
																<div>
																	<HashLink
																		smooth
																		className="text-black group relative hover:text-lime-500 text-center cursor-pointer transition-all duration-75 text-xl ease-in"
																		to={itemDictionary[item].to}
																	>
																		{item}
																	</HashLink>
																</div>
															) : (
																<div>
																	<span className="text-black">{item}</span>
																</div>
															)}
														</li>
													))}
												</ul>
											</div>
										)}
										{searchIsEmpty && (
											<div className="flex w-full flex-col items-center justify-between h-[80%] p-2 gap-2">
												<div className="flex group items-center justify-between w-full">
													<HashLink
														smooth
														onClick={() => {
															setTwo(false);
															setOne(false);
															setThree(true);
															setFour(false);
															setOpend(false);
															setSearchMenuOpen(false);
														}}
														className="text-black group-hover:text-lime-500  relative cursor-pointer transition-all duration-100 text-xl ease-in"
														to="/#Experience"
													>
														All Products
													</HashLink>
													<div>
														<svg
															className="group-hover:fill-lime-500 transition-all duration-75 fill-[#333]"
															width="11"
															height="19"
															viewBox="0 0 11 19"
															fill="none"
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																d="M2.15156 0.425L10.5766 8.825C10.6766 8.925 10.7472 9.03333 10.7886 9.15C10.8306 9.26667 10.8516 9.39167 10.8516 9.525C10.8516 9.65833 10.8306 9.78333 10.7886 9.9C10.7472 10.0167 10.6766 10.125 10.5766 10.225L2.15156 18.65C1.91823 18.8833 1.62656 19 1.27656 19C0.926562 19 0.626563 18.875 0.376563 18.625C0.126563 18.375 0.00156299 18.0833 0.00156296 17.75C0.00156293 17.4167 0.126563 17.125 0.376563 16.875L7.72656 9.525L0.376562 2.175C0.143228 1.94167 0.0265612 1.65433 0.0265611 1.313C0.0265611 0.971002 0.151561 0.675 0.401561 0.425C0.651561 0.175 0.943228 0.0500001 1.27656 0.0500001C1.60989 0.05 1.90156 0.175 2.15156 0.425Z"
																fill=""
															/>
														</svg>
													</div>
												</div>
												<div className="flex items-center group justify-between w-full gap-2">
													<HashLink
														smooth
														className="text-black  flex items-center  justify-center gap-2 relative cursor-pointer   group-hover:text-lime-500    transition-all duration-75 text-lg ease-in"
														onClick={() => {
															setExploreButton(true);
															setSearchMenuOpen(false);
															setOpend(false);
														}}
														to="/"
													>
														OnDemand™
													</HashLink>
													<div>
														<svg
															className="group-hover:fill-lime-500 transition-all duration-75 fill-[#333]"
															width="11"
															height="19"
															viewBox="0 0 11 19"
															fill="none"
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																d="M2.15156 0.425L10.5766 8.825C10.6766 8.925 10.7472 9.03333 10.7886 9.15C10.8306 9.26667 10.8516 9.39167 10.8516 9.525C10.8516 9.65833 10.8306 9.78333 10.7886 9.9C10.7472 10.0167 10.6766 10.125 10.5766 10.225L2.15156 18.65C1.91823 18.8833 1.62656 19 1.27656 19C0.926562 19 0.626563 18.875 0.376563 18.625C0.126563 18.375 0.00156299 18.0833 0.00156296 17.75C0.00156293 17.4167 0.126563 17.125 0.376563 16.875L7.72656 9.525L0.376562 2.175C0.143228 1.94167 0.0265612 1.65433 0.0265611 1.313C0.0265611 0.971002 0.151561 0.675 0.401561 0.425C0.651561 0.175 0.943228 0.0500001 1.27656 0.0500001C1.60989 0.05 1.90156 0.175 2.15156 0.425Z"
																fill=""
															/>
														</svg>
													</div>
												</div>
												<div className="flex items-center group justify-between w-full">
													<HashLink
														smooth
														onClick={() => {
															setTwo(false);
															setOne(false);
															setThree(true);
															setFour(false);
															setOpend(false);
															setSearchMenuOpen(false);
														}}
														className="text-black group-hover:text-lime-500  relative cursor-pointer transition-all duration-100 text-xl ease-in"
														to="/#Solutions"
													>
														Solutions
													</HashLink>
													<div>
														<svg
															className="group-hover:fill-lime-500 transition-all duration-75 fill-[#333]"
															width="11"
															height="19"
															viewBox="0 0 11 19"
															fill="none"
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																d="M2.15156 0.425L10.5766 8.825C10.6766 8.925 10.7472 9.03333 10.7886 9.15C10.8306 9.26667 10.8516 9.39167 10.8516 9.525C10.8516 9.65833 10.8306 9.78333 10.7886 9.9C10.7472 10.0167 10.6766 10.125 10.5766 10.225L2.15156 18.65C1.91823 18.8833 1.62656 19 1.27656 19C0.926562 19 0.626563 18.875 0.376563 18.625C0.126563 18.375 0.00156299 18.0833 0.00156296 17.75C0.00156293 17.4167 0.126563 17.125 0.376563 16.875L7.72656 9.525L0.376562 2.175C0.143228 1.94167 0.0265612 1.65433 0.0265611 1.313C0.0265611 0.971002 0.151561 0.675 0.401561 0.425C0.651561 0.175 0.943228 0.0500001 1.27656 0.0500001C1.60989 0.05 1.90156 0.175 2.15156 0.425Z"
																fill=""
															/>
														</svg>
													</div>
												</div>

												<div
													// onMouseEnter={() => {
													// 	setExploreMenu(false);
													// 	setMyGrowthStageOpener(
													// 		false
													// 	);
													// 	setMyRoleOpener(false);
													// 	setOpend(false);
													// }}
													className="flex items-center group justify-between w-full"
												>
													<div
														onClick={() => {
															setOne(true);
															setTwo(false);
															setThree(false);
															setFour(false);
															setOpend(false);
															setSearchMenuOpen(false);
														}}
														className="w-fit"
													>
														<HashLink
															smooth
															className="text-black  relative   group-hover:text-lime-500   text-center  cursor-pointer transition-all duration-75 text-xl ease-in"
															to="/#Bundles"
														>
															Packages
														</HashLink>
													</div>
													<div>
														<svg
															className="group-hover:fill-lime-500 transition-all duration-75 fill-[#333]"
															width="11"
															height="19"
															viewBox="0 0 11 19"
															fill="none"
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																d="M2.15156 0.425L10.5766 8.825C10.6766 8.925 10.7472 9.03333 10.7886 9.15C10.8306 9.26667 10.8516 9.39167 10.8516 9.525C10.8516 9.65833 10.8306 9.78333 10.7886 9.9C10.7472 10.0167 10.6766 10.125 10.5766 10.225L2.15156 18.65C1.91823 18.8833 1.62656 19 1.27656 19C0.926562 19 0.626563 18.875 0.376563 18.625C0.126563 18.375 0.00156299 18.0833 0.00156296 17.75C0.00156293 17.4167 0.126563 17.125 0.376563 16.875L7.72656 9.525L0.376562 2.175C0.143228 1.94167 0.0265612 1.65433 0.0265611 1.313C0.0265611 0.971002 0.151561 0.675 0.401561 0.425C0.651561 0.175 0.943228 0.0500001 1.27656 0.0500001C1.60989 0.05 1.90156 0.175 2.15156 0.425Z"
																fill=""
															/>
														</svg>
													</div>
												</div>
												<div
													onMouseEnter={() => {
														setExploreMenu(false);
														setMyGrowthStageOpener(false);
														setMyRoleOpener(false);
														setOpend(false);
													}}
													className="flex items-center group justify-between w-full"
												>
													<HashLink
														smooth
														className="text-black  relative cursor-pointer   group-hover:text-lime-500   text-center transition-all duration-75 text-xl ease-in"
														onClick={() => {
															setOne(true);
															setTwo(false);
															setThree(false);
															setFour(false);
															setSearchMenuOpen(false);
														}}
														to="/#Bundles"
													>
														Bundles
													</HashLink>
													<div>
														<svg
															className="group-hover:fill-lime-500 transition-all duration-75 fill-[#333]"
															width="11"
															height="19"
															viewBox="0 0 11 19"
															fill="none"
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																d="M2.15156 0.425L10.5766 8.825C10.6766 8.925 10.7472 9.03333 10.7886 9.15C10.8306 9.26667 10.8516 9.39167 10.8516 9.525C10.8516 9.65833 10.8306 9.78333 10.7886 9.9C10.7472 10.0167 10.6766 10.125 10.5766 10.225L2.15156 18.65C1.91823 18.8833 1.62656 19 1.27656 19C0.926562 19 0.626563 18.875 0.376563 18.625C0.126563 18.375 0.00156299 18.0833 0.00156296 17.75C0.00156293 17.4167 0.126563 17.125 0.376563 16.875L7.72656 9.525L0.376562 2.175C0.143228 1.94167 0.0265612 1.65433 0.0265611 1.313C0.0265611 0.971002 0.151561 0.675 0.401561 0.425C0.651561 0.175 0.943228 0.0500001 1.27656 0.0500001C1.60989 0.05 1.90156 0.175 2.15156 0.425Z"
																fill=""
															/>
														</svg>
													</div>
												</div>
												<div className="flex items-center justify-between w-full">
													<HashLink
														smooth
														className="text-black group relative cursor-pointer   hover:text-lime-500   text-center transition-all duration-75 text-xl ease-in"
														onClick={() => {
															setSearchMenuOpen(false);
															setOpend(false);
														}}
														to="/#Explore"
													>
														Explore
													</HashLink>
													<div>
														<svg
															className={`${
																ExploreMenu
																	? "fill-lime-500 transition-all duration-100 ease-in"
																	: "fill-[#333] transition-all duration-100 ease-in"
															} transition-all duration-150 ease-in`}
															width="11"
															height="19"
															viewBox="0 0 11 19"
															fill=""
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																d="M2.15156 0.425L10.5766 8.825C10.6766 8.925 10.7472 9.03333 10.7886 9.15C10.8306 9.26667 10.8516 9.39167 10.8516 9.525C10.8516 9.65833 10.8306 9.78333 10.7886 9.9C10.7472 10.0167 10.6766 10.125 10.5766 10.225L2.15156 18.65C1.91823 18.8833 1.62656 19 1.27656 19C0.926562 19 0.626563 18.875 0.376563 18.625C0.126563 18.375 0.00156299 18.0833 0.00156296 17.75C0.00156293 17.4167 0.126563 17.125 0.376563 16.875L7.72656 9.525L0.376562 2.175C0.143228 1.94167 0.0265612 1.65433 0.0265611 1.313C0.0265611 0.971002 0.151561 0.675 0.401561 0.425C0.651561 0.175 0.943228 0.0500001 1.27656 0.0500001C1.60989 0.05 1.90156 0.175 2.15156 0.425Z"
																fill=""
															/>
														</svg>
													</div>
												</div>
											</div>
										)}
									</div>
								)}
								{profileUser && (
									<div className="flex  w-full h-full items-center justify-center">
										<div className=" w-full h-full p-1     flex-row  items-start justify-center    ">
											<form
												onSubmit={handleSubmit}
												className="  lg:scale-100 flex    transition-all duration-300 ease-in   w-full bg-white md:bg-white     cursor-pointer   flex-col items-center justify-between  h-[85%]"
											>
												<input
													className=" p-2 w-full text-black border-t-0 border-b-1 border-slate-600  outline-1 outline outline-slate-300 rounded-sm "
													type="email"
													name="Email"
													ref={linkRef}
													value={email}
													onChange={(e) => setEmail(e.target.value)}
													placeholder="Email"
													required
													id="#email"
												/>
												<input
													className=" p-2 w-full text-black border-t-0 border-b-1 border-slate-600  outline-1 outline outline-slate-300 rounded-sm "
													type="password"
													name="password"
													id="#password"
													placeholder="Password"
													required
												/>
												<button
													type="submit"
													className=" p-2  rounded w-full text-center font-semibold border-lime-500 border   overflow-hidden group  relative hover:bg-gradient-to-r hover:from-lime-500 hover:to-lime-400 text-black hover:ring-2 hover:ring-offset-2 hover:ring-lime-400 transition-all ease-out duration-300"
												>
													<span className="relative ">Login</span>
												</button>
												<a
													href="https://calendly.com/salesbox-meet/salesmrkt?back=1&month=2025-11"
													target="_blank"
													rel="noopener noreferrer"
													className=" p-2  rounded w-full text-center font-semibold border-lime-500 border   overflow-hidden group  relative hover:bg-gradient-to-r hover:from-lime-500 hover:to-lime-400 text-black hover:ring-2 hover:ring-offset-2 hover:ring-lime-400 transition-all ease-out duration-300"
												>
													<span className="relative ">Sign Up</span>
												</a>
												<div className="w-full flex justify-between  mb-1">
													<div className="flex select-none  items-center w-1/2 ">
														<label
															htmlFor="#Remember"
															className="flex items-center cursor-pointer  gap-2"
														>
															<input
																className="w-5 h-5 cursor-pointer"
																type="checkbox"
																name="Remember"
																id="#Remember"
															/>
															<h4 className="text-sm text-black font-normal hover:text-blue-400 transition-all duration-75 ease-in">
																Remember Me
															</h4>
														</label>
													</div>
													<a
														className="text-sm text-black hover:text-blue-400 transition-all duration-75 ease-in"
														href="/"
													>
														Forgot Password
													</a>
												</div>
												<div className="w-full flex items-center justify-center  gap-6">
													<a
														href="/"
														className="w-[48px] h-[48px] border-2 rounded-lg flex items-center justify-center "
													>
														<img
															src={Google}
															alt="Google Icon"
															className=" p-1 hover:scale-110 transition-all duration-75 ease-in"
														/>
													</a>
													<a
														href="/"
														className="w-[48px] h-[48px] border-2 rounded-lg flex items-center justify-center"
													>
														<img
															src={Microsoft}
															alt="Microsoft Icon"
															className=" p-1 hover:scale-110 transition-all duration-75 ease-in "
														/>
													</a>
													<a
														href="/"
														className="w-[48px] h-[48px] border-2 rounded-lg flex items-center justify-center "
													>
														<img
															src={Apple}
															alt="Apple Icon"
															className=" p-1 hover:scale-110 transition-all duration-75 ease-in"
														/>
													</a>
												</div>
												<div className="flex text-black items-center justify-center gap-2">
													<p>{`${city}`}</p>
													<p>-</p>
													<p>{`${monthDate}`}</p>
												</div>
											</form>
										</div>
									</div>
								)}
								{Cart && (
									<div className=" ">
										<a
											href="https://calendly.com/salesbox-meet/salesmrkt"
											target="_blank"
											className="w-full h-full flex flex-col gap-1 items-center  justify-center"
											rel="noopener noreferrer"
										>
											<div className=" mb-3">
												<svg
													width="50"
													height="49"
													viewBox="0 0 30 35"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														fillRule="evenodd"
														clipRule="evenodd"
														d="M24.0276 21.3142L24.0251 21.3142L2.12173 21.3142C2.08775 21.3141 2.05625 21.3276 2.03386 21.3498C2.01201 21.3714 2.00051 21.3996 2.00004 21.4279L2.00391 21.4406L5.02329 32.0566C5.1 32.3269 5.26345 32.5659 5.48996 32.7366C5.71658 32.9074 5.99367 33.0002 6.27911 33H19.8656C20.1544 32.9986 20.4345 32.9043 20.6642 32.732C20.8928 32.5605 21.0592 32.321 21.14 32.0496L24.1303 21.5352L24.145 21.3993C24.1397 21.3811 24.1298 21.364 24.1154 21.3498C24.0931 21.3276 24.0616 21.3141 24.0276 21.3142ZM26.1493 21.4206C26.1493 21.4543 26.1473 21.4879 26.1434 21.5213L26.1089 21.8415C26.1028 21.8933 26.0928 21.9446 26.0789 21.9948L23.0611 32.6058C22.8594 33.2949 22.4396 33.9004 21.8643 34.3319C21.2891 34.7634 20.5892 34.9978 19.8694 35H6.28054C5.56076 35.0005 4.86051 34.7666 4.28627 34.3339C3.71203 33.9011 3.29523 33.2932 3.09925 32.6025L0.0853663 22.0059C0.0275909 21.8164 -0.00117629 21.6193 3.68235e-05 21.4213C0.00227836 20.8611 0.22723 20.3247 0.625552 19.9297C1.02387 19.5346 1.56304 19.3133 2.1248 19.3142H6.30073L12.2412 11.4157C12.3251 11.3041 12.4306 11.2107 12.5511 11.1408C12.57 11.1299 12.5893 11.1195 12.6089 11.1097C12.7536 11.0376 12.9132 11 13.075 11C13.2368 11 13.3963 11.0376 13.5411 11.1097C13.5607 11.1195 13.5799 11.1299 13.5988 11.1408C13.7194 11.2107 13.8248 11.3041 13.9087 11.4157L19.8492 19.3142H24.0251C24.5867 19.3135 25.1256 19.5348 25.5237 19.9297C25.9219 20.3245 26.1468 20.8607 26.1493 21.4206ZM8.90621 19.3142L13.075 13.7716L17.2437 19.3142H8.90621Z"
														fill="black"
													/>
													<path
														d="M23.744 8.572C23.744 7.196 23.968 6.124 24.416 5.356C24.864 4.58 25.648 4.192 26.768 4.192C27.88 4.192 28.66 4.58 29.108 5.356C29.556 6.124 29.78 7.196 29.78 8.572C29.78 9.972 29.556 11.06 29.108 11.836C28.66 12.612 27.88 13 26.768 13C25.648 13 24.864 12.612 24.416 11.836C23.968 11.06 23.744 9.972 23.744 8.572ZM28.7 8.572C28.7 7.876 28.652 7.288 28.556 6.808C28.468 6.32 28.28 5.928 27.992 5.632C27.712 5.336 27.304 5.188 26.768 5.188C26.224 5.188 25.808 5.336 25.52 5.632C25.24 5.928 25.052 6.32 24.956 6.808C24.868 7.288 24.824 7.876 24.824 8.572C24.824 9.292 24.868 9.896 24.956 10.384C25.052 10.872 25.24 11.264 25.52 11.56C25.808 11.856 26.224 12.004 26.768 12.004C27.304 12.004 27.712 11.856 27.992 11.56C28.28 11.264 28.468 10.872 28.556 10.384C28.652 9.896 28.7 9.292 28.7 8.572Z"
														fill="black"
													/>
												</svg>
											</div>
											<h3 className="text-black/80  mb-3 ">
												Your cart is empty
											</h3>
											<a
												href="https://calendly.com/salesbox-meet/salesmrkt"
												target="_blank"
												className="relative  flex items-center justify-center"
												rel="noopener noreferrer"
											>
												<img
													src={CardImageMoney}
													alt=""
													className=" w-[100%]   mt-3 "
												/>
											</a>
											<a
												href="https://calendly.com/salesbox-meet/salesmrkt"
												target="_blank"
												className="text-[#84CC16] mt-3  hover:scale-105 transition-all duration-200 ease-in  "
												rel="noopener noreferrer"
											>
												Get Started {">"}
											</a>
										</a>
									</div>
								)}
							</div>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default NavBar;
